/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SsoRouteImport } from './routes/sso'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AuthProfileRouteImport } from './routes/_auth/profile'
import { Route as AuthUsersIndexRouteImport } from './routes/_auth/users/index'
import { Route as AuthAttendanceIndexRouteImport } from './routes/_auth/attendance/index'
import { Route as AuthUsersViewRouteImport } from './routes/_auth/users/view'
import { Route as AuthUsersSpecialRouteImport } from './routes/_auth/users/special'
import { Route as AuthUsersRolesRouteImport } from './routes/_auth/users/roles'
import { Route as AuthUsersMarketingRouteImport } from './routes/_auth/users/marketing'
import { Route as AuthUsersGeneralRouteImport } from './routes/_auth/users/general'
import { Route as AuthUsersEditRouteImport } from './routes/_auth/users/edit'
import { Route as AuthUsersAgentRouteImport } from './routes/_auth/users/agent'
import { Route as AuthUsersAdminRouteImport } from './routes/_auth/users/admin'
import { Route as AuthSettingsWebUrlsRouteImport } from './routes/_auth/settings/web-urls'
import { Route as AuthSettingsLimitTypesRouteImport } from './routes/_auth/settings/limit-types'
import { Route as AuthSettingsLeaveTypesRouteImport } from './routes/_auth/settings/leave-types'
import { Route as AuthSettingsInstituteTypesRouteImport } from './routes/_auth/settings/institute-types'
import { Route as AuthSettingsFeedbackTypesRouteImport } from './routes/_auth/settings/feedback-types'
import { Route as AuthReportsAppVersionCheckRouteImport } from './routes/_auth/reports/app-version-check'
import { Route as AuthQuestionUploadRouteImport } from './routes/_auth/question/upload'
import { Route as AuthQuestionSubjectsRouteImport } from './routes/_auth/question/subjects'
import { Route as AuthQuestionProjectsRouteImport } from './routes/_auth/question/projects'
import { Route as AuthQuestionDownloadByClassRouteImport } from './routes/_auth/question/download-by-class'
import { Route as AuthQuestionDownloadByBoardRouteImport } from './routes/_auth/question/download-by-board'
import { Route as AuthQuestionDownloadRouteImport } from './routes/_auth/question/download'
import { Route as AuthPublishSalesRouteImport } from './routes/_auth/publish/sales'
import { Route as AuthPublishMisRouteImport } from './routes/_auth/publish/mis'
import { Route as AuthPublishAccountsRouteImport } from './routes/_auth/publish/accounts'
import { Route as AuthPromotionItemsRouteImport } from './routes/_auth/promotion/items'
import { Route as AuthPromotionItemTypesRouteImport } from './routes/_auth/promotion/item-types'
import { Route as AuthPromotionDistributionRouteImport } from './routes/_auth/promotion/distribution'
import { Route as AuthProductSpecimensRouteImport } from './routes/_auth/product/specimens'
import { Route as AuthProductSpecimenListViewRouteImport } from './routes/_auth/product/specimen-list-view'
import { Route as AuthProductSpecimenInstitutionRouteImport } from './routes/_auth/product/specimen-institution'
import { Route as AuthProductSpecimenAdjustmentRouteImport } from './routes/_auth/product/specimen-adjustment'
import { Route as AuthProductDcrSheetRouteImport } from './routes/_auth/product/dcr-sheet'
import { Route as AuthProductDcrDateToDateRouteImport } from './routes/_auth/product/dcr-date-to-date'
import { Route as AuthProductBookTypesRouteImport } from './routes/_auth/product/book-types'
import { Route as AuthProductBookEditionsRouteImport } from './routes/_auth/product/book-editions'
import { Route as AuthMarketPromotionRequisitionsRouteImport } from './routes/_auth/market-promotion/requisitions'
import { Route as AuthMarketPromotionRegionSummaryRouteImport } from './routes/_auth/market-promotion/region-summary'
import { Route as AuthMarketPromotionPublishPanelRouteImport } from './routes/_auth/market-promotion/publish-panel'
import { Route as AuthMarketPromotionProjectsRouteImport } from './routes/_auth/market-promotion/projects'
import { Route as AuthMarketPromotionMisApprovalsRouteImport } from './routes/_auth/market-promotion/mis-approvals'
import { Route as AuthMarketPromotionDistributionSummaryRouteImport } from './routes/_auth/market-promotion/distribution-summary'
import { Route as AuthMarketPromotionCashCollectionRouteImport } from './routes/_auth/market-promotion/cash-collection'
import { Route as AuthMarketPromotionBudgetEntryRouteImport } from './routes/_auth/market-promotion/budget-entry'
import { Route as AuthMarketPromotionApprovalsRouteImport } from './routes/_auth/market-promotion/approvals'
import { Route as AuthMarketPromotionApprovalReportRouteImport } from './routes/_auth/market-promotion/approval-report'
import { Route as AuthMarketPromotionAccountsAdjustRouteImport } from './routes/_auth/market-promotion/accounts-adjust'
import { Route as AuthHrFormLeaveReportRouteImport } from './routes/_auth/hr-form/leave-report'
import { Route as AuthFeedbackTypesRouteImport } from './routes/_auth/feedback/types'
import { Route as AuthFeedbackListRouteImport } from './routes/_auth/feedback/list'
import { Route as AuthDashboardsPendingRouteImport } from './routes/_auth/dashboards/pending'
import { Route as AuthDashboardsDerRouteImport } from './routes/_auth/dashboards/der'
import { Route as AuthBillingWebExpenseRouteImport } from './routes/_auth/billing/web-expense'
import { Route as AuthBillingOfflineDerVerifyRouteImport } from './routes/_auth/billing/offline-der-verify'
import { Route as AuthBillingOfflineDcrVerifyRouteImport } from './routes/_auth/billing/offline-dcr-verify'
import { Route as AuthBillingExpenseApproveRouteImport } from './routes/_auth/billing/expense-approve'
import { Route as AuthBillingDcrApproveRouteImport } from './routes/_auth/billing/dcr-approve'
import { Route as AuthBillingCostAmendmentRouteImport } from './routes/_auth/billing/cost-amendment'
import { Route as AuthBillingApprovalRouteImport } from './routes/_auth/billing/approval'
import { Route as AuthBillingAllCostRouteImport } from './routes/_auth/billing/all-cost'
import { Route as AuthAttendanceShiftJobCardRouteImport } from './routes/_auth/attendance/shift-job-card'
import { Route as AuthAttendanceShiftEmployeeReportRouteImport } from './routes/_auth/attendance/shift-employee-report'
import { Route as AuthAttendanceJobCardRouteImport } from './routes/_auth/attendance/job-card'
import { Route as AuthAttendanceEmployeeReportRouteImport } from './routes/_auth/attendance/employee-report'
import { Route as AuthSettingsTeacherSubmissionsIndexRouteImport } from './routes/_auth/settings/teacher-submissions/index'
import { Route as AuthSettingsInstitutesIndexRouteImport } from './routes/_auth/settings/institutes/index'
import { Route as AuthSettingsInstituteSubmissionsIndexRouteImport } from './routes/_auth/settings/institute-submissions/index'
import { Route as AuthPromotionAdjustmentIndexRouteImport } from './routes/_auth/promotion/adjustment/index'
import { Route as AuthProductSpecimenDistributionIndexRouteImport } from './routes/_auth/product/specimen-distribution/index'
import { Route as AuthMarketPromotionAdjustmentIndexRouteImport } from './routes/_auth/market-promotion/adjustment/index'
import { Route as AuthHrFormLeaveApplicationsIndexRouteImport } from './routes/_auth/hr-form/leave-applications/index'
import { Route as AuthGeoLocationMoTravelHistoryIndexRouteImport } from './routes/_auth/geo-location/mo-travel-history/index'
import { Route as AuthFeedbackSurveysIndexRouteImport } from './routes/_auth/feedback/surveys/index'
import { Route as AuthDashboardsZonalStatementIndexRouteImport } from './routes/_auth/dashboards/zonal-statement/index'
import { Route as AuthDashboardsSystemIndexRouteImport } from './routes/_auth/dashboards/system/index'
import { Route as AuthDashboardsDcrIndexRouteImport } from './routes/_auth/dashboards/dcr/index'
import { Route as AuthUsersCreateCategoryRouteImport } from './routes/_auth/users/create.$category'
import { Route as AuthSettingsTeacherSubmissionsTeacherIdRouteImport } from './routes/_auth/settings/teacher-submissions/$teacherId'
import { Route as AuthSettingsInstitutesUserMappingRouteImport } from './routes/_auth/settings/institutes/user-mapping'
import { Route as AuthSettingsInstitutesCreateRouteImport } from './routes/_auth/settings/institutes/create'
import { Route as AuthSettingsInstituteSubmissionsSubmissionIdRouteImport } from './routes/_auth/settings/institute-submissions/$submissionId'
import { Route as AuthQuestionPapersProjectInstituteIdRouteImport } from './routes/_auth/question/papers/$projectInstituteId'
import { Route as AuthQuestionMonitorDistrictsRouteImport } from './routes/_auth/question/monitor/districts'
import { Route as AuthQuestionMonitorClassesRouteImport } from './routes/_auth/question/monitor/classes'
import { Route as AuthPublishBatchesBatchIdRouteImport } from './routes/_auth/publish/batches/$batchId'
import { Route as AuthHrFormLeaveApplicationsApplicationIdRouteImport } from './routes/_auth/hr-form/leave-applications/$applicationId'
import { Route as AuthGeoLocationMoTravelHistoryUserIdRouteImport } from './routes/_auth/geo-location/mo-travel-history/$userId'
import { Route as AuthFeedbackSurveysNewRouteImport } from './routes/_auth/feedback/surveys/new'
import { Route as AuthDashboardsSystemUserIdRouteImport } from './routes/_auth/dashboards/system/$userId'
import { Route as AuthDashboardsDcrUserIdRouteImport } from './routes/_auth/dashboards/dcr/$userId'
import { Route as AuthQuestionMonitorInstitutesIndexRouteImport } from './routes/_auth/question/monitor/institutes/index'
import { Route as AuthPromotionAdjustmentPromoItemIdIndexRouteImport } from './routes/_auth/promotion/adjustment/$promoItemId/index'
import { Route as AuthProductSpecimenDistributionSpecimenIdIndexRouteImport } from './routes/_auth/product/specimen-distribution/$specimenId/index'
import { Route as AuthMarketPromotionAdjustmentPromoItemIdIndexRouteImport } from './routes/_auth/market-promotion/adjustment/$promoItemId/index'
import { Route as AuthFeedbackSurveysSurveyIdIndexRouteImport } from './routes/_auth/feedback/surveys/$surveyId/index'
import { Route as AuthSettingsInstitutesInstituteIdEditRouteImport } from './routes/_auth/settings/institutes/$instituteId/edit'
import { Route as AuthQuestionMonitorInstitutesProjectInstituteIdRouteImport } from './routes/_auth/question/monitor/institutes/$projectInstituteId'
import { Route as AuthPromotionAdjustmentPromoItemIdZmIdRouteImport } from './routes/_auth/promotion/adjustment/$promoItemId/$zmId'
import { Route as AuthProductSpecimenDistributionSpecimenIdZmIdRouteImport } from './routes/_auth/product/specimen-distribution/$specimenId/$zmId'
import { Route as AuthMarketPromotionAdjustmentPromoItemIdZmIdRouteImport } from './routes/_auth/market-promotion/adjustment/$promoItemId/$zmId'
import { Route as AuthFeedbackSurveysSurveyIdSubmissionsRouteImport } from './routes/_auth/feedback/surveys/$surveyId/submissions'
import { Route as AuthFeedbackSurveysSurveyIdEditRouteImport } from './routes/_auth/feedback/surveys/$surveyId/edit'
import { Route as AuthDashboardsZonalStatementUserIdSpecimenRouteImport } from './routes/_auth/dashboards/zonal-statement/$userId/specimen'
import { Route as AuthDashboardsZonalStatementUserIdExpenseRouteImport } from './routes/_auth/dashboards/zonal-statement/$userId/expense'

const SsoRoute = SsoRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const AuthProfileRoute = AuthProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersIndexRoute = AuthUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAttendanceIndexRoute = AuthAttendanceIndexRouteImport.update({
  id: '/attendance/',
  path: '/attendance/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersViewRoute = AuthUsersViewRouteImport.update({
  id: '/users/view',
  path: '/users/view',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersSpecialRoute = AuthUsersSpecialRouteImport.update({
  id: '/users/special',
  path: '/users/special',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersRolesRoute = AuthUsersRolesRouteImport.update({
  id: '/users/roles',
  path: '/users/roles',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersMarketingRoute = AuthUsersMarketingRouteImport.update({
  id: '/users/marketing',
  path: '/users/marketing',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersGeneralRoute = AuthUsersGeneralRouteImport.update({
  id: '/users/general',
  path: '/users/general',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersEditRoute = AuthUsersEditRouteImport.update({
  id: '/users/edit',
  path: '/users/edit',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersAgentRoute = AuthUsersAgentRouteImport.update({
  id: '/users/agent',
  path: '/users/agent',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersAdminRoute = AuthUsersAdminRouteImport.update({
  id: '/users/admin',
  path: '/users/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsWebUrlsRoute = AuthSettingsWebUrlsRouteImport.update({
  id: '/settings/web-urls',
  path: '/settings/web-urls',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsLimitTypesRoute = AuthSettingsLimitTypesRouteImport.update({
  id: '/settings/limit-types',
  path: '/settings/limit-types',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsLeaveTypesRoute = AuthSettingsLeaveTypesRouteImport.update({
  id: '/settings/leave-types',
  path: '/settings/leave-types',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsInstituteTypesRoute =
  AuthSettingsInstituteTypesRouteImport.update({
    id: '/settings/institute-types',
    path: '/settings/institute-types',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsFeedbackTypesRoute =
  AuthSettingsFeedbackTypesRouteImport.update({
    id: '/settings/feedback-types',
    path: '/settings/feedback-types',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthReportsAppVersionCheckRoute =
  AuthReportsAppVersionCheckRouteImport.update({
    id: '/reports/app-version-check',
    path: '/reports/app-version-check',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionUploadRoute = AuthQuestionUploadRouteImport.update({
  id: '/question/upload',
  path: '/question/upload',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQuestionSubjectsRoute = AuthQuestionSubjectsRouteImport.update({
  id: '/question/subjects',
  path: '/question/subjects',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQuestionProjectsRoute = AuthQuestionProjectsRouteImport.update({
  id: '/question/projects',
  path: '/question/projects',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQuestionDownloadByClassRoute =
  AuthQuestionDownloadByClassRouteImport.update({
    id: '/question/download-by-class',
    path: '/question/download-by-class',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionDownloadByBoardRoute =
  AuthQuestionDownloadByBoardRouteImport.update({
    id: '/question/download-by-board',
    path: '/question/download-by-board',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionDownloadRoute = AuthQuestionDownloadRouteImport.update({
  id: '/question/download',
  path: '/question/download',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPublishSalesRoute = AuthPublishSalesRouteImport.update({
  id: '/publish/sales',
  path: '/publish/sales',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPublishMisRoute = AuthPublishMisRouteImport.update({
  id: '/publish/mis',
  path: '/publish/mis',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPublishAccountsRoute = AuthPublishAccountsRouteImport.update({
  id: '/publish/accounts',
  path: '/publish/accounts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPromotionItemsRoute = AuthPromotionItemsRouteImport.update({
  id: '/promotion/items',
  path: '/promotion/items',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPromotionItemTypesRoute = AuthPromotionItemTypesRouteImport.update({
  id: '/promotion/item-types',
  path: '/promotion/item-types',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPromotionDistributionRoute =
  AuthPromotionDistributionRouteImport.update({
    id: '/promotion/distribution',
    path: '/promotion/distribution',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimensRoute = AuthProductSpecimensRouteImport.update({
  id: '/product/specimens',
  path: '/product/specimens',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProductSpecimenListViewRoute =
  AuthProductSpecimenListViewRouteImport.update({
    id: '/product/specimen-list-view',
    path: '/product/specimen-list-view',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenInstitutionRoute =
  AuthProductSpecimenInstitutionRouteImport.update({
    id: '/product/specimen-institution',
    path: '/product/specimen-institution',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenAdjustmentRoute =
  AuthProductSpecimenAdjustmentRouteImport.update({
    id: '/product/specimen-adjustment',
    path: '/product/specimen-adjustment',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductDcrSheetRoute = AuthProductDcrSheetRouteImport.update({
  id: '/product/dcr-sheet',
  path: '/product/dcr-sheet',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProductDcrDateToDateRoute =
  AuthProductDcrDateToDateRouteImport.update({
    id: '/product/dcr-date-to-date',
    path: '/product/dcr-date-to-date',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductBookTypesRoute = AuthProductBookTypesRouteImport.update({
  id: '/product/book-types',
  path: '/product/book-types',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProductBookEditionsRoute = AuthProductBookEditionsRouteImport.update({
  id: '/product/book-editions',
  path: '/product/book-editions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMarketPromotionRequisitionsRoute =
  AuthMarketPromotionRequisitionsRouteImport.update({
    id: '/market-promotion/requisitions',
    path: '/market-promotion/requisitions',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionRegionSummaryRoute =
  AuthMarketPromotionRegionSummaryRouteImport.update({
    id: '/market-promotion/region-summary',
    path: '/market-promotion/region-summary',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionPublishPanelRoute =
  AuthMarketPromotionPublishPanelRouteImport.update({
    id: '/market-promotion/publish-panel',
    path: '/market-promotion/publish-panel',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionProjectsRoute =
  AuthMarketPromotionProjectsRouteImport.update({
    id: '/market-promotion/projects',
    path: '/market-promotion/projects',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionMisApprovalsRoute =
  AuthMarketPromotionMisApprovalsRouteImport.update({
    id: '/market-promotion/mis-approvals',
    path: '/market-promotion/mis-approvals',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionDistributionSummaryRoute =
  AuthMarketPromotionDistributionSummaryRouteImport.update({
    id: '/market-promotion/distribution-summary',
    path: '/market-promotion/distribution-summary',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionCashCollectionRoute =
  AuthMarketPromotionCashCollectionRouteImport.update({
    id: '/market-promotion/cash-collection',
    path: '/market-promotion/cash-collection',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionBudgetEntryRoute =
  AuthMarketPromotionBudgetEntryRouteImport.update({
    id: '/market-promotion/budget-entry',
    path: '/market-promotion/budget-entry',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionApprovalsRoute =
  AuthMarketPromotionApprovalsRouteImport.update({
    id: '/market-promotion/approvals',
    path: '/market-promotion/approvals',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionApprovalReportRoute =
  AuthMarketPromotionApprovalReportRouteImport.update({
    id: '/market-promotion/approval-report',
    path: '/market-promotion/approval-report',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionAccountsAdjustRoute =
  AuthMarketPromotionAccountsAdjustRouteImport.update({
    id: '/market-promotion/accounts-adjust',
    path: '/market-promotion/accounts-adjust',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthHrFormLeaveReportRoute = AuthHrFormLeaveReportRouteImport.update({
  id: '/hr-form/leave-report',
  path: '/hr-form/leave-report',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFeedbackTypesRoute = AuthFeedbackTypesRouteImport.update({
  id: '/feedback/types',
  path: '/feedback/types',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFeedbackListRoute = AuthFeedbackListRouteImport.update({
  id: '/feedback/list',
  path: '/feedback/list',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardsPendingRoute = AuthDashboardsPendingRouteImport.update({
  id: '/dashboards/pending',
  path: '/dashboards/pending',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardsDerRoute = AuthDashboardsDerRouteImport.update({
  id: '/dashboards/der',
  path: '/dashboards/der',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingWebExpenseRoute = AuthBillingWebExpenseRouteImport.update({
  id: '/billing/web-expense',
  path: '/billing/web-expense',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingOfflineDerVerifyRoute =
  AuthBillingOfflineDerVerifyRouteImport.update({
    id: '/billing/offline-der-verify',
    path: '/billing/offline-der-verify',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBillingOfflineDcrVerifyRoute =
  AuthBillingOfflineDcrVerifyRouteImport.update({
    id: '/billing/offline-dcr-verify',
    path: '/billing/offline-dcr-verify',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBillingExpenseApproveRoute =
  AuthBillingExpenseApproveRouteImport.update({
    id: '/billing/expense-approve',
    path: '/billing/expense-approve',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBillingDcrApproveRoute = AuthBillingDcrApproveRouteImport.update({
  id: '/billing/dcr-approve',
  path: '/billing/dcr-approve',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingCostAmendmentRoute =
  AuthBillingCostAmendmentRouteImport.update({
    id: '/billing/cost-amendment',
    path: '/billing/cost-amendment',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthBillingApprovalRoute = AuthBillingApprovalRouteImport.update({
  id: '/billing/approval',
  path: '/billing/approval',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingAllCostRoute = AuthBillingAllCostRouteImport.update({
  id: '/billing/all-cost',
  path: '/billing/all-cost',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAttendanceShiftJobCardRoute =
  AuthAttendanceShiftJobCardRouteImport.update({
    id: '/attendance/shift-job-card',
    path: '/attendance/shift-job-card',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAttendanceShiftEmployeeReportRoute =
  AuthAttendanceShiftEmployeeReportRouteImport.update({
    id: '/attendance/shift-employee-report',
    path: '/attendance/shift-employee-report',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAttendanceJobCardRoute = AuthAttendanceJobCardRouteImport.update({
  id: '/attendance/job-card',
  path: '/attendance/job-card',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAttendanceEmployeeReportRoute =
  AuthAttendanceEmployeeReportRouteImport.update({
    id: '/attendance/employee-report',
    path: '/attendance/employee-report',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsTeacherSubmissionsIndexRoute =
  AuthSettingsTeacherSubmissionsIndexRouteImport.update({
    id: '/settings/teacher-submissions/',
    path: '/settings/teacher-submissions/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsInstitutesIndexRoute =
  AuthSettingsInstitutesIndexRouteImport.update({
    id: '/settings/institutes/',
    path: '/settings/institutes/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsInstituteSubmissionsIndexRoute =
  AuthSettingsInstituteSubmissionsIndexRouteImport.update({
    id: '/settings/institute-submissions/',
    path: '/settings/institute-submissions/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPromotionAdjustmentIndexRoute =
  AuthPromotionAdjustmentIndexRouteImport.update({
    id: '/promotion/adjustment/',
    path: '/promotion/adjustment/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenDistributionIndexRoute =
  AuthProductSpecimenDistributionIndexRouteImport.update({
    id: '/product/specimen-distribution/',
    path: '/product/specimen-distribution/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionAdjustmentIndexRoute =
  AuthMarketPromotionAdjustmentIndexRouteImport.update({
    id: '/market-promotion/adjustment/',
    path: '/market-promotion/adjustment/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthHrFormLeaveApplicationsIndexRoute =
  AuthHrFormLeaveApplicationsIndexRouteImport.update({
    id: '/hr-form/leave-applications/',
    path: '/hr-form/leave-applications/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGeoLocationMoTravelHistoryIndexRoute =
  AuthGeoLocationMoTravelHistoryIndexRouteImport.update({
    id: '/geo-location/mo-travel-history/',
    path: '/geo-location/mo-travel-history/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeedbackSurveysIndexRoute =
  AuthFeedbackSurveysIndexRouteImport.update({
    id: '/feedback/surveys/',
    path: '/feedback/surveys/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsZonalStatementIndexRoute =
  AuthDashboardsZonalStatementIndexRouteImport.update({
    id: '/dashboards/zonal-statement/',
    path: '/dashboards/zonal-statement/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsSystemIndexRoute =
  AuthDashboardsSystemIndexRouteImport.update({
    id: '/dashboards/system/',
    path: '/dashboards/system/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsDcrIndexRoute = AuthDashboardsDcrIndexRouteImport.update({
  id: '/dashboards/dcr/',
  path: '/dashboards/dcr/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsersCreateCategoryRoute = AuthUsersCreateCategoryRouteImport.update({
  id: '/users/create/$category',
  path: '/users/create/$category',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsTeacherSubmissionsTeacherIdRoute =
  AuthSettingsTeacherSubmissionsTeacherIdRouteImport.update({
    id: '/settings/teacher-submissions/$teacherId',
    path: '/settings/teacher-submissions/$teacherId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsInstitutesUserMappingRoute =
  AuthSettingsInstitutesUserMappingRouteImport.update({
    id: '/settings/institutes/user-mapping',
    path: '/settings/institutes/user-mapping',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsInstitutesCreateRoute =
  AuthSettingsInstitutesCreateRouteImport.update({
    id: '/settings/institutes/create',
    path: '/settings/institutes/create',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsInstituteSubmissionsSubmissionIdRoute =
  AuthSettingsInstituteSubmissionsSubmissionIdRouteImport.update({
    id: '/settings/institute-submissions/$submissionId',
    path: '/settings/institute-submissions/$submissionId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionPapersProjectInstituteIdRoute =
  AuthQuestionPapersProjectInstituteIdRouteImport.update({
    id: '/question/papers/$projectInstituteId',
    path: '/question/papers/$projectInstituteId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionMonitorDistrictsRoute =
  AuthQuestionMonitorDistrictsRouteImport.update({
    id: '/question/monitor/districts',
    path: '/question/monitor/districts',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionMonitorClassesRoute =
  AuthQuestionMonitorClassesRouteImport.update({
    id: '/question/monitor/classes',
    path: '/question/monitor/classes',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPublishBatchesBatchIdRoute =
  AuthPublishBatchesBatchIdRouteImport.update({
    id: '/publish/batches/$batchId',
    path: '/publish/batches/$batchId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthHrFormLeaveApplicationsApplicationIdRoute =
  AuthHrFormLeaveApplicationsApplicationIdRouteImport.update({
    id: '/hr-form/leave-applications/$applicationId',
    path: '/hr-form/leave-applications/$applicationId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGeoLocationMoTravelHistoryUserIdRoute =
  AuthGeoLocationMoTravelHistoryUserIdRouteImport.update({
    id: '/geo-location/mo-travel-history/$userId',
    path: '/geo-location/mo-travel-history/$userId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeedbackSurveysNewRoute = AuthFeedbackSurveysNewRouteImport.update({
  id: '/feedback/surveys/new',
  path: '/feedback/surveys/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardsSystemUserIdRoute =
  AuthDashboardsSystemUserIdRouteImport.update({
    id: '/dashboards/system/$userId',
    path: '/dashboards/system/$userId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsDcrUserIdRoute = AuthDashboardsDcrUserIdRouteImport.update({
  id: '/dashboards/dcr/$userId',
  path: '/dashboards/dcr/$userId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthQuestionMonitorInstitutesIndexRoute =
  AuthQuestionMonitorInstitutesIndexRouteImport.update({
    id: '/question/monitor/institutes/',
    path: '/question/monitor/institutes/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPromotionAdjustmentPromoItemIdIndexRoute =
  AuthPromotionAdjustmentPromoItemIdIndexRouteImport.update({
    id: '/promotion/adjustment/$promoItemId/',
    path: '/promotion/adjustment/$promoItemId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenDistributionSpecimenIdIndexRoute =
  AuthProductSpecimenDistributionSpecimenIdIndexRouteImport.update({
    id: '/product/specimen-distribution/$specimenId/',
    path: '/product/specimen-distribution/$specimenId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionAdjustmentPromoItemIdIndexRoute =
  AuthMarketPromotionAdjustmentPromoItemIdIndexRouteImport.update({
    id: '/market-promotion/adjustment/$promoItemId/',
    path: '/market-promotion/adjustment/$promoItemId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeedbackSurveysSurveyIdIndexRoute =
  AuthFeedbackSurveysSurveyIdIndexRouteImport.update({
    id: '/feedback/surveys/$surveyId/',
    path: '/feedback/surveys/$surveyId/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsInstitutesInstituteIdEditRoute =
  AuthSettingsInstitutesInstituteIdEditRouteImport.update({
    id: '/settings/institutes/$instituteId/edit',
    path: '/settings/institutes/$instituteId/edit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthQuestionMonitorInstitutesProjectInstituteIdRoute =
  AuthQuestionMonitorInstitutesProjectInstituteIdRouteImport.update({
    id: '/question/monitor/institutes/$projectInstituteId',
    path: '/question/monitor/institutes/$projectInstituteId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthPromotionAdjustmentPromoItemIdZmIdRoute =
  AuthPromotionAdjustmentPromoItemIdZmIdRouteImport.update({
    id: '/promotion/adjustment/$promoItemId/$zmId',
    path: '/promotion/adjustment/$promoItemId/$zmId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProductSpecimenDistributionSpecimenIdZmIdRoute =
  AuthProductSpecimenDistributionSpecimenIdZmIdRouteImport.update({
    id: '/product/specimen-distribution/$specimenId/$zmId',
    path: '/product/specimen-distribution/$specimenId/$zmId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute =
  AuthMarketPromotionAdjustmentPromoItemIdZmIdRouteImport.update({
    id: '/market-promotion/adjustment/$promoItemId/$zmId',
    path: '/market-promotion/adjustment/$promoItemId/$zmId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeedbackSurveysSurveyIdSubmissionsRoute =
  AuthFeedbackSurveysSurveyIdSubmissionsRouteImport.update({
    id: '/feedback/surveys/$surveyId/submissions',
    path: '/feedback/surveys/$surveyId/submissions',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthFeedbackSurveysSurveyIdEditRoute =
  AuthFeedbackSurveysSurveyIdEditRouteImport.update({
    id: '/feedback/surveys/$surveyId/edit',
    path: '/feedback/surveys/$surveyId/edit',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsZonalStatementUserIdSpecimenRoute =
  AuthDashboardsZonalStatementUserIdSpecimenRouteImport.update({
    id: '/dashboards/zonal-statement/$userId/specimen',
    path: '/dashboards/zonal-statement/$userId/specimen',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDashboardsZonalStatementUserIdExpenseRoute =
  AuthDashboardsZonalStatementUserIdExpenseRouteImport.update({
    id: '/dashboards/zonal-statement/$userId/expense',
    path: '/dashboards/zonal-statement/$userId/expense',
    getParentRoute: () => AuthRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/sso': typeof SsoRoute
  '/profile': typeof AuthProfileRoute
  '/login': typeof PublicLoginRoute
  '/attendance/employee-report': typeof AuthAttendanceEmployeeReportRoute
  '/attendance/job-card': typeof AuthAttendanceJobCardRoute
  '/attendance/shift-employee-report': typeof AuthAttendanceShiftEmployeeReportRoute
  '/attendance/shift-job-card': typeof AuthAttendanceShiftJobCardRoute
  '/billing/all-cost': typeof AuthBillingAllCostRoute
  '/billing/approval': typeof AuthBillingApprovalRoute
  '/billing/cost-amendment': typeof AuthBillingCostAmendmentRoute
  '/billing/dcr-approve': typeof AuthBillingDcrApproveRoute
  '/billing/expense-approve': typeof AuthBillingExpenseApproveRoute
  '/billing/offline-dcr-verify': typeof AuthBillingOfflineDcrVerifyRoute
  '/billing/offline-der-verify': typeof AuthBillingOfflineDerVerifyRoute
  '/billing/web-expense': typeof AuthBillingWebExpenseRoute
  '/dashboards/der': typeof AuthDashboardsDerRoute
  '/dashboards/pending': typeof AuthDashboardsPendingRoute
  '/feedback/list': typeof AuthFeedbackListRoute
  '/feedback/types': typeof AuthFeedbackTypesRoute
  '/hr-form/leave-report': typeof AuthHrFormLeaveReportRoute
  '/market-promotion/accounts-adjust': typeof AuthMarketPromotionAccountsAdjustRoute
  '/market-promotion/approval-report': typeof AuthMarketPromotionApprovalReportRoute
  '/market-promotion/approvals': typeof AuthMarketPromotionApprovalsRoute
  '/market-promotion/budget-entry': typeof AuthMarketPromotionBudgetEntryRoute
  '/market-promotion/cash-collection': typeof AuthMarketPromotionCashCollectionRoute
  '/market-promotion/distribution-summary': typeof AuthMarketPromotionDistributionSummaryRoute
  '/market-promotion/mis-approvals': typeof AuthMarketPromotionMisApprovalsRoute
  '/market-promotion/projects': typeof AuthMarketPromotionProjectsRoute
  '/market-promotion/publish-panel': typeof AuthMarketPromotionPublishPanelRoute
  '/market-promotion/region-summary': typeof AuthMarketPromotionRegionSummaryRoute
  '/market-promotion/requisitions': typeof AuthMarketPromotionRequisitionsRoute
  '/product/book-editions': typeof AuthProductBookEditionsRoute
  '/product/book-types': typeof AuthProductBookTypesRoute
  '/product/dcr-date-to-date': typeof AuthProductDcrDateToDateRoute
  '/product/dcr-sheet': typeof AuthProductDcrSheetRoute
  '/product/specimen-adjustment': typeof AuthProductSpecimenAdjustmentRoute
  '/product/specimen-institution': typeof AuthProductSpecimenInstitutionRoute
  '/product/specimen-list-view': typeof AuthProductSpecimenListViewRoute
  '/product/specimens': typeof AuthProductSpecimensRoute
  '/promotion/distribution': typeof AuthPromotionDistributionRoute
  '/promotion/item-types': typeof AuthPromotionItemTypesRoute
  '/promotion/items': typeof AuthPromotionItemsRoute
  '/publish/accounts': typeof AuthPublishAccountsRoute
  '/publish/mis': typeof AuthPublishMisRoute
  '/publish/sales': typeof AuthPublishSalesRoute
  '/question/download': typeof AuthQuestionDownloadRoute
  '/question/download-by-board': typeof AuthQuestionDownloadByBoardRoute
  '/question/download-by-class': typeof AuthQuestionDownloadByClassRoute
  '/question/projects': typeof AuthQuestionProjectsRoute
  '/question/subjects': typeof AuthQuestionSubjectsRoute
  '/question/upload': typeof AuthQuestionUploadRoute
  '/reports/app-version-check': typeof AuthReportsAppVersionCheckRoute
  '/settings/feedback-types': typeof AuthSettingsFeedbackTypesRoute
  '/settings/institute-types': typeof AuthSettingsInstituteTypesRoute
  '/settings/leave-types': typeof AuthSettingsLeaveTypesRoute
  '/settings/limit-types': typeof AuthSettingsLimitTypesRoute
  '/settings/web-urls': typeof AuthSettingsWebUrlsRoute
  '/users/admin': typeof AuthUsersAdminRoute
  '/users/agent': typeof AuthUsersAgentRoute
  '/users/edit': typeof AuthUsersEditRoute
  '/users/general': typeof AuthUsersGeneralRoute
  '/users/marketing': typeof AuthUsersMarketingRoute
  '/users/roles': typeof AuthUsersRolesRoute
  '/users/special': typeof AuthUsersSpecialRoute
  '/users/view': typeof AuthUsersViewRoute
  '/attendance/': typeof AuthAttendanceIndexRoute
  '/users/': typeof AuthUsersIndexRoute
  '/dashboards/dcr/$userId': typeof AuthDashboardsDcrUserIdRoute
  '/dashboards/system/$userId': typeof AuthDashboardsSystemUserIdRoute
  '/feedback/surveys/new': typeof AuthFeedbackSurveysNewRoute
  '/geo-location/mo-travel-history/$userId': typeof AuthGeoLocationMoTravelHistoryUserIdRoute
  '/hr-form/leave-applications/$applicationId': typeof AuthHrFormLeaveApplicationsApplicationIdRoute
  '/publish/batches/$batchId': typeof AuthPublishBatchesBatchIdRoute
  '/question/monitor/classes': typeof AuthQuestionMonitorClassesRoute
  '/question/monitor/districts': typeof AuthQuestionMonitorDistrictsRoute
  '/question/papers/$projectInstituteId': typeof AuthQuestionPapersProjectInstituteIdRoute
  '/settings/institute-submissions/$submissionId': typeof AuthSettingsInstituteSubmissionsSubmissionIdRoute
  '/settings/institutes/create': typeof AuthSettingsInstitutesCreateRoute
  '/settings/institutes/user-mapping': typeof AuthSettingsInstitutesUserMappingRoute
  '/settings/teacher-submissions/$teacherId': typeof AuthSettingsTeacherSubmissionsTeacherIdRoute
  '/users/create/$category': typeof AuthUsersCreateCategoryRoute
  '/dashboards/dcr/': typeof AuthDashboardsDcrIndexRoute
  '/dashboards/system/': typeof AuthDashboardsSystemIndexRoute
  '/dashboards/zonal-statement/': typeof AuthDashboardsZonalStatementIndexRoute
  '/feedback/surveys/': typeof AuthFeedbackSurveysIndexRoute
  '/geo-location/mo-travel-history/': typeof AuthGeoLocationMoTravelHistoryIndexRoute
  '/hr-form/leave-applications/': typeof AuthHrFormLeaveApplicationsIndexRoute
  '/market-promotion/adjustment/': typeof AuthMarketPromotionAdjustmentIndexRoute
  '/product/specimen-distribution/': typeof AuthProductSpecimenDistributionIndexRoute
  '/promotion/adjustment/': typeof AuthPromotionAdjustmentIndexRoute
  '/settings/institute-submissions/': typeof AuthSettingsInstituteSubmissionsIndexRoute
  '/settings/institutes/': typeof AuthSettingsInstitutesIndexRoute
  '/settings/teacher-submissions/': typeof AuthSettingsTeacherSubmissionsIndexRoute
  '/dashboards/zonal-statement/$userId/expense': typeof AuthDashboardsZonalStatementUserIdExpenseRoute
  '/dashboards/zonal-statement/$userId/specimen': typeof AuthDashboardsZonalStatementUserIdSpecimenRoute
  '/feedback/surveys/$surveyId/edit': typeof AuthFeedbackSurveysSurveyIdEditRoute
  '/feedback/surveys/$surveyId/submissions': typeof AuthFeedbackSurveysSurveyIdSubmissionsRoute
  '/market-promotion/adjustment/$promoItemId/$zmId': typeof AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute
  '/product/specimen-distribution/$specimenId/$zmId': typeof AuthProductSpecimenDistributionSpecimenIdZmIdRoute
  '/promotion/adjustment/$promoItemId/$zmId': typeof AuthPromotionAdjustmentPromoItemIdZmIdRoute
  '/question/monitor/institutes/$projectInstituteId': typeof AuthQuestionMonitorInstitutesProjectInstituteIdRoute
  '/settings/institutes/$instituteId/edit': typeof AuthSettingsInstitutesInstituteIdEditRoute
  '/feedback/surveys/$surveyId/': typeof AuthFeedbackSurveysSurveyIdIndexRoute
  '/market-promotion/adjustment/$promoItemId/': typeof AuthMarketPromotionAdjustmentPromoItemIdIndexRoute
  '/product/specimen-distribution/$specimenId/': typeof AuthProductSpecimenDistributionSpecimenIdIndexRoute
  '/promotion/adjustment/$promoItemId/': typeof AuthPromotionAdjustmentPromoItemIdIndexRoute
  '/question/monitor/institutes/': typeof AuthQuestionMonitorInstitutesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthIndexRoute
  '/sso': typeof SsoRoute
  '/profile': typeof AuthProfileRoute
  '/login': typeof PublicLoginRoute
  '/attendance/employee-report': typeof AuthAttendanceEmployeeReportRoute
  '/attendance/job-card': typeof AuthAttendanceJobCardRoute
  '/attendance/shift-employee-report': typeof AuthAttendanceShiftEmployeeReportRoute
  '/attendance/shift-job-card': typeof AuthAttendanceShiftJobCardRoute
  '/billing/all-cost': typeof AuthBillingAllCostRoute
  '/billing/approval': typeof AuthBillingApprovalRoute
  '/billing/cost-amendment': typeof AuthBillingCostAmendmentRoute
  '/billing/dcr-approve': typeof AuthBillingDcrApproveRoute
  '/billing/expense-approve': typeof AuthBillingExpenseApproveRoute
  '/billing/offline-dcr-verify': typeof AuthBillingOfflineDcrVerifyRoute
  '/billing/offline-der-verify': typeof AuthBillingOfflineDerVerifyRoute
  '/billing/web-expense': typeof AuthBillingWebExpenseRoute
  '/dashboards/der': typeof AuthDashboardsDerRoute
  '/dashboards/pending': typeof AuthDashboardsPendingRoute
  '/feedback/list': typeof AuthFeedbackListRoute
  '/feedback/types': typeof AuthFeedbackTypesRoute
  '/hr-form/leave-report': typeof AuthHrFormLeaveReportRoute
  '/market-promotion/accounts-adjust': typeof AuthMarketPromotionAccountsAdjustRoute
  '/market-promotion/approval-report': typeof AuthMarketPromotionApprovalReportRoute
  '/market-promotion/approvals': typeof AuthMarketPromotionApprovalsRoute
  '/market-promotion/budget-entry': typeof AuthMarketPromotionBudgetEntryRoute
  '/market-promotion/cash-collection': typeof AuthMarketPromotionCashCollectionRoute
  '/market-promotion/distribution-summary': typeof AuthMarketPromotionDistributionSummaryRoute
  '/market-promotion/mis-approvals': typeof AuthMarketPromotionMisApprovalsRoute
  '/market-promotion/projects': typeof AuthMarketPromotionProjectsRoute
  '/market-promotion/publish-panel': typeof AuthMarketPromotionPublishPanelRoute
  '/market-promotion/region-summary': typeof AuthMarketPromotionRegionSummaryRoute
  '/market-promotion/requisitions': typeof AuthMarketPromotionRequisitionsRoute
  '/product/book-editions': typeof AuthProductBookEditionsRoute
  '/product/book-types': typeof AuthProductBookTypesRoute
  '/product/dcr-date-to-date': typeof AuthProductDcrDateToDateRoute
  '/product/dcr-sheet': typeof AuthProductDcrSheetRoute
  '/product/specimen-adjustment': typeof AuthProductSpecimenAdjustmentRoute
  '/product/specimen-institution': typeof AuthProductSpecimenInstitutionRoute
  '/product/specimen-list-view': typeof AuthProductSpecimenListViewRoute
  '/product/specimens': typeof AuthProductSpecimensRoute
  '/promotion/distribution': typeof AuthPromotionDistributionRoute
  '/promotion/item-types': typeof AuthPromotionItemTypesRoute
  '/promotion/items': typeof AuthPromotionItemsRoute
  '/publish/accounts': typeof AuthPublishAccountsRoute
  '/publish/mis': typeof AuthPublishMisRoute
  '/publish/sales': typeof AuthPublishSalesRoute
  '/question/download': typeof AuthQuestionDownloadRoute
  '/question/download-by-board': typeof AuthQuestionDownloadByBoardRoute
  '/question/download-by-class': typeof AuthQuestionDownloadByClassRoute
  '/question/projects': typeof AuthQuestionProjectsRoute
  '/question/subjects': typeof AuthQuestionSubjectsRoute
  '/question/upload': typeof AuthQuestionUploadRoute
  '/reports/app-version-check': typeof AuthReportsAppVersionCheckRoute
  '/settings/feedback-types': typeof AuthSettingsFeedbackTypesRoute
  '/settings/institute-types': typeof AuthSettingsInstituteTypesRoute
  '/settings/leave-types': typeof AuthSettingsLeaveTypesRoute
  '/settings/limit-types': typeof AuthSettingsLimitTypesRoute
  '/settings/web-urls': typeof AuthSettingsWebUrlsRoute
  '/users/admin': typeof AuthUsersAdminRoute
  '/users/agent': typeof AuthUsersAgentRoute
  '/users/edit': typeof AuthUsersEditRoute
  '/users/general': typeof AuthUsersGeneralRoute
  '/users/marketing': typeof AuthUsersMarketingRoute
  '/users/roles': typeof AuthUsersRolesRoute
  '/users/special': typeof AuthUsersSpecialRoute
  '/users/view': typeof AuthUsersViewRoute
  '/attendance': typeof AuthAttendanceIndexRoute
  '/users': typeof AuthUsersIndexRoute
  '/dashboards/dcr/$userId': typeof AuthDashboardsDcrUserIdRoute
  '/dashboards/system/$userId': typeof AuthDashboardsSystemUserIdRoute
  '/feedback/surveys/new': typeof AuthFeedbackSurveysNewRoute
  '/geo-location/mo-travel-history/$userId': typeof AuthGeoLocationMoTravelHistoryUserIdRoute
  '/hr-form/leave-applications/$applicationId': typeof AuthHrFormLeaveApplicationsApplicationIdRoute
  '/publish/batches/$batchId': typeof AuthPublishBatchesBatchIdRoute
  '/question/monitor/classes': typeof AuthQuestionMonitorClassesRoute
  '/question/monitor/districts': typeof AuthQuestionMonitorDistrictsRoute
  '/question/papers/$projectInstituteId': typeof AuthQuestionPapersProjectInstituteIdRoute
  '/settings/institute-submissions/$submissionId': typeof AuthSettingsInstituteSubmissionsSubmissionIdRoute
  '/settings/institutes/create': typeof AuthSettingsInstitutesCreateRoute
  '/settings/institutes/user-mapping': typeof AuthSettingsInstitutesUserMappingRoute
  '/settings/teacher-submissions/$teacherId': typeof AuthSettingsTeacherSubmissionsTeacherIdRoute
  '/users/create/$category': typeof AuthUsersCreateCategoryRoute
  '/dashboards/dcr': typeof AuthDashboardsDcrIndexRoute
  '/dashboards/system': typeof AuthDashboardsSystemIndexRoute
  '/dashboards/zonal-statement': typeof AuthDashboardsZonalStatementIndexRoute
  '/feedback/surveys': typeof AuthFeedbackSurveysIndexRoute
  '/geo-location/mo-travel-history': typeof AuthGeoLocationMoTravelHistoryIndexRoute
  '/hr-form/leave-applications': typeof AuthHrFormLeaveApplicationsIndexRoute
  '/market-promotion/adjustment': typeof AuthMarketPromotionAdjustmentIndexRoute
  '/product/specimen-distribution': typeof AuthProductSpecimenDistributionIndexRoute
  '/promotion/adjustment': typeof AuthPromotionAdjustmentIndexRoute
  '/settings/institute-submissions': typeof AuthSettingsInstituteSubmissionsIndexRoute
  '/settings/institutes': typeof AuthSettingsInstitutesIndexRoute
  '/settings/teacher-submissions': typeof AuthSettingsTeacherSubmissionsIndexRoute
  '/dashboards/zonal-statement/$userId/expense': typeof AuthDashboardsZonalStatementUserIdExpenseRoute
  '/dashboards/zonal-statement/$userId/specimen': typeof AuthDashboardsZonalStatementUserIdSpecimenRoute
  '/feedback/surveys/$surveyId/edit': typeof AuthFeedbackSurveysSurveyIdEditRoute
  '/feedback/surveys/$surveyId/submissions': typeof AuthFeedbackSurveysSurveyIdSubmissionsRoute
  '/market-promotion/adjustment/$promoItemId/$zmId': typeof AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute
  '/product/specimen-distribution/$specimenId/$zmId': typeof AuthProductSpecimenDistributionSpecimenIdZmIdRoute
  '/promotion/adjustment/$promoItemId/$zmId': typeof AuthPromotionAdjustmentPromoItemIdZmIdRoute
  '/question/monitor/institutes/$projectInstituteId': typeof AuthQuestionMonitorInstitutesProjectInstituteIdRoute
  '/settings/institutes/$instituteId/edit': typeof AuthSettingsInstitutesInstituteIdEditRoute
  '/feedback/surveys/$surveyId': typeof AuthFeedbackSurveysSurveyIdIndexRoute
  '/market-promotion/adjustment/$promoItemId': typeof AuthMarketPromotionAdjustmentPromoItemIdIndexRoute
  '/product/specimen-distribution/$specimenId': typeof AuthProductSpecimenDistributionSpecimenIdIndexRoute
  '/promotion/adjustment/$promoItemId': typeof AuthPromotionAdjustmentPromoItemIdIndexRoute
  '/question/monitor/institutes': typeof AuthQuestionMonitorInstitutesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/sso': typeof SsoRoute
  '/_auth/profile': typeof AuthProfileRoute
  '/_public/login': typeof PublicLoginRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/attendance/employee-report': typeof AuthAttendanceEmployeeReportRoute
  '/_auth/attendance/job-card': typeof AuthAttendanceJobCardRoute
  '/_auth/attendance/shift-employee-report': typeof AuthAttendanceShiftEmployeeReportRoute
  '/_auth/attendance/shift-job-card': typeof AuthAttendanceShiftJobCardRoute
  '/_auth/billing/all-cost': typeof AuthBillingAllCostRoute
  '/_auth/billing/approval': typeof AuthBillingApprovalRoute
  '/_auth/billing/cost-amendment': typeof AuthBillingCostAmendmentRoute
  '/_auth/billing/dcr-approve': typeof AuthBillingDcrApproveRoute
  '/_auth/billing/expense-approve': typeof AuthBillingExpenseApproveRoute
  '/_auth/billing/offline-dcr-verify': typeof AuthBillingOfflineDcrVerifyRoute
  '/_auth/billing/offline-der-verify': typeof AuthBillingOfflineDerVerifyRoute
  '/_auth/billing/web-expense': typeof AuthBillingWebExpenseRoute
  '/_auth/dashboards/der': typeof AuthDashboardsDerRoute
  '/_auth/dashboards/pending': typeof AuthDashboardsPendingRoute
  '/_auth/feedback/list': typeof AuthFeedbackListRoute
  '/_auth/feedback/types': typeof AuthFeedbackTypesRoute
  '/_auth/hr-form/leave-report': typeof AuthHrFormLeaveReportRoute
  '/_auth/market-promotion/accounts-adjust': typeof AuthMarketPromotionAccountsAdjustRoute
  '/_auth/market-promotion/approval-report': typeof AuthMarketPromotionApprovalReportRoute
  '/_auth/market-promotion/approvals': typeof AuthMarketPromotionApprovalsRoute
  '/_auth/market-promotion/budget-entry': typeof AuthMarketPromotionBudgetEntryRoute
  '/_auth/market-promotion/cash-collection': typeof AuthMarketPromotionCashCollectionRoute
  '/_auth/market-promotion/distribution-summary': typeof AuthMarketPromotionDistributionSummaryRoute
  '/_auth/market-promotion/mis-approvals': typeof AuthMarketPromotionMisApprovalsRoute
  '/_auth/market-promotion/projects': typeof AuthMarketPromotionProjectsRoute
  '/_auth/market-promotion/publish-panel': typeof AuthMarketPromotionPublishPanelRoute
  '/_auth/market-promotion/region-summary': typeof AuthMarketPromotionRegionSummaryRoute
  '/_auth/market-promotion/requisitions': typeof AuthMarketPromotionRequisitionsRoute
  '/_auth/product/book-editions': typeof AuthProductBookEditionsRoute
  '/_auth/product/book-types': typeof AuthProductBookTypesRoute
  '/_auth/product/dcr-date-to-date': typeof AuthProductDcrDateToDateRoute
  '/_auth/product/dcr-sheet': typeof AuthProductDcrSheetRoute
  '/_auth/product/specimen-adjustment': typeof AuthProductSpecimenAdjustmentRoute
  '/_auth/product/specimen-institution': typeof AuthProductSpecimenInstitutionRoute
  '/_auth/product/specimen-list-view': typeof AuthProductSpecimenListViewRoute
  '/_auth/product/specimens': typeof AuthProductSpecimensRoute
  '/_auth/promotion/distribution': typeof AuthPromotionDistributionRoute
  '/_auth/promotion/item-types': typeof AuthPromotionItemTypesRoute
  '/_auth/promotion/items': typeof AuthPromotionItemsRoute
  '/_auth/publish/accounts': typeof AuthPublishAccountsRoute
  '/_auth/publish/mis': typeof AuthPublishMisRoute
  '/_auth/publish/sales': typeof AuthPublishSalesRoute
  '/_auth/question/download': typeof AuthQuestionDownloadRoute
  '/_auth/question/download-by-board': typeof AuthQuestionDownloadByBoardRoute
  '/_auth/question/download-by-class': typeof AuthQuestionDownloadByClassRoute
  '/_auth/question/projects': typeof AuthQuestionProjectsRoute
  '/_auth/question/subjects': typeof AuthQuestionSubjectsRoute
  '/_auth/question/upload': typeof AuthQuestionUploadRoute
  '/_auth/reports/app-version-check': typeof AuthReportsAppVersionCheckRoute
  '/_auth/settings/feedback-types': typeof AuthSettingsFeedbackTypesRoute
  '/_auth/settings/institute-types': typeof AuthSettingsInstituteTypesRoute
  '/_auth/settings/leave-types': typeof AuthSettingsLeaveTypesRoute
  '/_auth/settings/limit-types': typeof AuthSettingsLimitTypesRoute
  '/_auth/settings/web-urls': typeof AuthSettingsWebUrlsRoute
  '/_auth/users/admin': typeof AuthUsersAdminRoute
  '/_auth/users/agent': typeof AuthUsersAgentRoute
  '/_auth/users/edit': typeof AuthUsersEditRoute
  '/_auth/users/general': typeof AuthUsersGeneralRoute
  '/_auth/users/marketing': typeof AuthUsersMarketingRoute
  '/_auth/users/roles': typeof AuthUsersRolesRoute
  '/_auth/users/special': typeof AuthUsersSpecialRoute
  '/_auth/users/view': typeof AuthUsersViewRoute
  '/_auth/attendance/': typeof AuthAttendanceIndexRoute
  '/_auth/users/': typeof AuthUsersIndexRoute
  '/_auth/dashboards/dcr/$userId': typeof AuthDashboardsDcrUserIdRoute
  '/_auth/dashboards/system/$userId': typeof AuthDashboardsSystemUserIdRoute
  '/_auth/feedback/surveys/new': typeof AuthFeedbackSurveysNewRoute
  '/_auth/geo-location/mo-travel-history/$userId': typeof AuthGeoLocationMoTravelHistoryUserIdRoute
  '/_auth/hr-form/leave-applications/$applicationId': typeof AuthHrFormLeaveApplicationsApplicationIdRoute
  '/_auth/publish/batches/$batchId': typeof AuthPublishBatchesBatchIdRoute
  '/_auth/question/monitor/classes': typeof AuthQuestionMonitorClassesRoute
  '/_auth/question/monitor/districts': typeof AuthQuestionMonitorDistrictsRoute
  '/_auth/question/papers/$projectInstituteId': typeof AuthQuestionPapersProjectInstituteIdRoute
  '/_auth/settings/institute-submissions/$submissionId': typeof AuthSettingsInstituteSubmissionsSubmissionIdRoute
  '/_auth/settings/institutes/create': typeof AuthSettingsInstitutesCreateRoute
  '/_auth/settings/institutes/user-mapping': typeof AuthSettingsInstitutesUserMappingRoute
  '/_auth/settings/teacher-submissions/$teacherId': typeof AuthSettingsTeacherSubmissionsTeacherIdRoute
  '/_auth/users/create/$category': typeof AuthUsersCreateCategoryRoute
  '/_auth/dashboards/dcr/': typeof AuthDashboardsDcrIndexRoute
  '/_auth/dashboards/system/': typeof AuthDashboardsSystemIndexRoute
  '/_auth/dashboards/zonal-statement/': typeof AuthDashboardsZonalStatementIndexRoute
  '/_auth/feedback/surveys/': typeof AuthFeedbackSurveysIndexRoute
  '/_auth/geo-location/mo-travel-history/': typeof AuthGeoLocationMoTravelHistoryIndexRoute
  '/_auth/hr-form/leave-applications/': typeof AuthHrFormLeaveApplicationsIndexRoute
  '/_auth/market-promotion/adjustment/': typeof AuthMarketPromotionAdjustmentIndexRoute
  '/_auth/product/specimen-distribution/': typeof AuthProductSpecimenDistributionIndexRoute
  '/_auth/promotion/adjustment/': typeof AuthPromotionAdjustmentIndexRoute
  '/_auth/settings/institute-submissions/': typeof AuthSettingsInstituteSubmissionsIndexRoute
  '/_auth/settings/institutes/': typeof AuthSettingsInstitutesIndexRoute
  '/_auth/settings/teacher-submissions/': typeof AuthSettingsTeacherSubmissionsIndexRoute
  '/_auth/dashboards/zonal-statement/$userId/expense': typeof AuthDashboardsZonalStatementUserIdExpenseRoute
  '/_auth/dashboards/zonal-statement/$userId/specimen': typeof AuthDashboardsZonalStatementUserIdSpecimenRoute
  '/_auth/feedback/surveys/$surveyId/edit': typeof AuthFeedbackSurveysSurveyIdEditRoute
  '/_auth/feedback/surveys/$surveyId/submissions': typeof AuthFeedbackSurveysSurveyIdSubmissionsRoute
  '/_auth/market-promotion/adjustment/$promoItemId/$zmId': typeof AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute
  '/_auth/product/specimen-distribution/$specimenId/$zmId': typeof AuthProductSpecimenDistributionSpecimenIdZmIdRoute
  '/_auth/promotion/adjustment/$promoItemId/$zmId': typeof AuthPromotionAdjustmentPromoItemIdZmIdRoute
  '/_auth/question/monitor/institutes/$projectInstituteId': typeof AuthQuestionMonitorInstitutesProjectInstituteIdRoute
  '/_auth/settings/institutes/$instituteId/edit': typeof AuthSettingsInstitutesInstituteIdEditRoute
  '/_auth/feedback/surveys/$surveyId/': typeof AuthFeedbackSurveysSurveyIdIndexRoute
  '/_auth/market-promotion/adjustment/$promoItemId/': typeof AuthMarketPromotionAdjustmentPromoItemIdIndexRoute
  '/_auth/product/specimen-distribution/$specimenId/': typeof AuthProductSpecimenDistributionSpecimenIdIndexRoute
  '/_auth/promotion/adjustment/$promoItemId/': typeof AuthPromotionAdjustmentPromoItemIdIndexRoute
  '/_auth/question/monitor/institutes/': typeof AuthQuestionMonitorInstitutesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sso'
    | '/profile'
    | '/login'
    | '/attendance/employee-report'
    | '/attendance/job-card'
    | '/attendance/shift-employee-report'
    | '/attendance/shift-job-card'
    | '/billing/all-cost'
    | '/billing/approval'
    | '/billing/cost-amendment'
    | '/billing/dcr-approve'
    | '/billing/expense-approve'
    | '/billing/offline-dcr-verify'
    | '/billing/offline-der-verify'
    | '/billing/web-expense'
    | '/dashboards/der'
    | '/dashboards/pending'
    | '/feedback/list'
    | '/feedback/types'
    | '/hr-form/leave-report'
    | '/market-promotion/accounts-adjust'
    | '/market-promotion/approval-report'
    | '/market-promotion/approvals'
    | '/market-promotion/budget-entry'
    | '/market-promotion/cash-collection'
    | '/market-promotion/distribution-summary'
    | '/market-promotion/mis-approvals'
    | '/market-promotion/projects'
    | '/market-promotion/publish-panel'
    | '/market-promotion/region-summary'
    | '/market-promotion/requisitions'
    | '/product/book-editions'
    | '/product/book-types'
    | '/product/dcr-date-to-date'
    | '/product/dcr-sheet'
    | '/product/specimen-adjustment'
    | '/product/specimen-institution'
    | '/product/specimen-list-view'
    | '/product/specimens'
    | '/promotion/distribution'
    | '/promotion/item-types'
    | '/promotion/items'
    | '/publish/accounts'
    | '/publish/mis'
    | '/publish/sales'
    | '/question/download'
    | '/question/download-by-board'
    | '/question/download-by-class'
    | '/question/projects'
    | '/question/subjects'
    | '/question/upload'
    | '/reports/app-version-check'
    | '/settings/feedback-types'
    | '/settings/institute-types'
    | '/settings/leave-types'
    | '/settings/limit-types'
    | '/settings/web-urls'
    | '/users/admin'
    | '/users/agent'
    | '/users/edit'
    | '/users/general'
    | '/users/marketing'
    | '/users/roles'
    | '/users/special'
    | '/users/view'
    | '/attendance/'
    | '/users/'
    | '/dashboards/dcr/$userId'
    | '/dashboards/system/$userId'
    | '/feedback/surveys/new'
    | '/geo-location/mo-travel-history/$userId'
    | '/hr-form/leave-applications/$applicationId'
    | '/publish/batches/$batchId'
    | '/question/monitor/classes'
    | '/question/monitor/districts'
    | '/question/papers/$projectInstituteId'
    | '/settings/institute-submissions/$submissionId'
    | '/settings/institutes/create'
    | '/settings/institutes/user-mapping'
    | '/settings/teacher-submissions/$teacherId'
    | '/users/create/$category'
    | '/dashboards/dcr/'
    | '/dashboards/system/'
    | '/dashboards/zonal-statement/'
    | '/feedback/surveys/'
    | '/geo-location/mo-travel-history/'
    | '/hr-form/leave-applications/'
    | '/market-promotion/adjustment/'
    | '/product/specimen-distribution/'
    | '/promotion/adjustment/'
    | '/settings/institute-submissions/'
    | '/settings/institutes/'
    | '/settings/teacher-submissions/'
    | '/dashboards/zonal-statement/$userId/expense'
    | '/dashboards/zonal-statement/$userId/specimen'
    | '/feedback/surveys/$surveyId/edit'
    | '/feedback/surveys/$surveyId/submissions'
    | '/market-promotion/adjustment/$promoItemId/$zmId'
    | '/product/specimen-distribution/$specimenId/$zmId'
    | '/promotion/adjustment/$promoItemId/$zmId'
    | '/question/monitor/institutes/$projectInstituteId'
    | '/settings/institutes/$instituteId/edit'
    | '/feedback/surveys/$surveyId/'
    | '/market-promotion/adjustment/$promoItemId/'
    | '/product/specimen-distribution/$specimenId/'
    | '/promotion/adjustment/$promoItemId/'
    | '/question/monitor/institutes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sso'
    | '/profile'
    | '/login'
    | '/attendance/employee-report'
    | '/attendance/job-card'
    | '/attendance/shift-employee-report'
    | '/attendance/shift-job-card'
    | '/billing/all-cost'
    | '/billing/approval'
    | '/billing/cost-amendment'
    | '/billing/dcr-approve'
    | '/billing/expense-approve'
    | '/billing/offline-dcr-verify'
    | '/billing/offline-der-verify'
    | '/billing/web-expense'
    | '/dashboards/der'
    | '/dashboards/pending'
    | '/feedback/list'
    | '/feedback/types'
    | '/hr-form/leave-report'
    | '/market-promotion/accounts-adjust'
    | '/market-promotion/approval-report'
    | '/market-promotion/approvals'
    | '/market-promotion/budget-entry'
    | '/market-promotion/cash-collection'
    | '/market-promotion/distribution-summary'
    | '/market-promotion/mis-approvals'
    | '/market-promotion/projects'
    | '/market-promotion/publish-panel'
    | '/market-promotion/region-summary'
    | '/market-promotion/requisitions'
    | '/product/book-editions'
    | '/product/book-types'
    | '/product/dcr-date-to-date'
    | '/product/dcr-sheet'
    | '/product/specimen-adjustment'
    | '/product/specimen-institution'
    | '/product/specimen-list-view'
    | '/product/specimens'
    | '/promotion/distribution'
    | '/promotion/item-types'
    | '/promotion/items'
    | '/publish/accounts'
    | '/publish/mis'
    | '/publish/sales'
    | '/question/download'
    | '/question/download-by-board'
    | '/question/download-by-class'
    | '/question/projects'
    | '/question/subjects'
    | '/question/upload'
    | '/reports/app-version-check'
    | '/settings/feedback-types'
    | '/settings/institute-types'
    | '/settings/leave-types'
    | '/settings/limit-types'
    | '/settings/web-urls'
    | '/users/admin'
    | '/users/agent'
    | '/users/edit'
    | '/users/general'
    | '/users/marketing'
    | '/users/roles'
    | '/users/special'
    | '/users/view'
    | '/attendance'
    | '/users'
    | '/dashboards/dcr/$userId'
    | '/dashboards/system/$userId'
    | '/feedback/surveys/new'
    | '/geo-location/mo-travel-history/$userId'
    | '/hr-form/leave-applications/$applicationId'
    | '/publish/batches/$batchId'
    | '/question/monitor/classes'
    | '/question/monitor/districts'
    | '/question/papers/$projectInstituteId'
    | '/settings/institute-submissions/$submissionId'
    | '/settings/institutes/create'
    | '/settings/institutes/user-mapping'
    | '/settings/teacher-submissions/$teacherId'
    | '/users/create/$category'
    | '/dashboards/dcr'
    | '/dashboards/system'
    | '/dashboards/zonal-statement'
    | '/feedback/surveys'
    | '/geo-location/mo-travel-history'
    | '/hr-form/leave-applications'
    | '/market-promotion/adjustment'
    | '/product/specimen-distribution'
    | '/promotion/adjustment'
    | '/settings/institute-submissions'
    | '/settings/institutes'
    | '/settings/teacher-submissions'
    | '/dashboards/zonal-statement/$userId/expense'
    | '/dashboards/zonal-statement/$userId/specimen'
    | '/feedback/surveys/$surveyId/edit'
    | '/feedback/surveys/$surveyId/submissions'
    | '/market-promotion/adjustment/$promoItemId/$zmId'
    | '/product/specimen-distribution/$specimenId/$zmId'
    | '/promotion/adjustment/$promoItemId/$zmId'
    | '/question/monitor/institutes/$projectInstituteId'
    | '/settings/institutes/$instituteId/edit'
    | '/feedback/surveys/$surveyId'
    | '/market-promotion/adjustment/$promoItemId'
    | '/product/specimen-distribution/$specimenId'
    | '/promotion/adjustment/$promoItemId'
    | '/question/monitor/institutes'
  id:
    | '__root__'
    | '/_auth'
    | '/_public'
    | '/sso'
    | '/_auth/profile'
    | '/_public/login'
    | '/_auth/'
    | '/_auth/attendance/employee-report'
    | '/_auth/attendance/job-card'
    | '/_auth/attendance/shift-employee-report'
    | '/_auth/attendance/shift-job-card'
    | '/_auth/billing/all-cost'
    | '/_auth/billing/approval'
    | '/_auth/billing/cost-amendment'
    | '/_auth/billing/dcr-approve'
    | '/_auth/billing/expense-approve'
    | '/_auth/billing/offline-dcr-verify'
    | '/_auth/billing/offline-der-verify'
    | '/_auth/billing/web-expense'
    | '/_auth/dashboards/der'
    | '/_auth/dashboards/pending'
    | '/_auth/feedback/list'
    | '/_auth/feedback/types'
    | '/_auth/hr-form/leave-report'
    | '/_auth/market-promotion/accounts-adjust'
    | '/_auth/market-promotion/approval-report'
    | '/_auth/market-promotion/approvals'
    | '/_auth/market-promotion/budget-entry'
    | '/_auth/market-promotion/cash-collection'
    | '/_auth/market-promotion/distribution-summary'
    | '/_auth/market-promotion/mis-approvals'
    | '/_auth/market-promotion/projects'
    | '/_auth/market-promotion/publish-panel'
    | '/_auth/market-promotion/region-summary'
    | '/_auth/market-promotion/requisitions'
    | '/_auth/product/book-editions'
    | '/_auth/product/book-types'
    | '/_auth/product/dcr-date-to-date'
    | '/_auth/product/dcr-sheet'
    | '/_auth/product/specimen-adjustment'
    | '/_auth/product/specimen-institution'
    | '/_auth/product/specimen-list-view'
    | '/_auth/product/specimens'
    | '/_auth/promotion/distribution'
    | '/_auth/promotion/item-types'
    | '/_auth/promotion/items'
    | '/_auth/publish/accounts'
    | '/_auth/publish/mis'
    | '/_auth/publish/sales'
    | '/_auth/question/download'
    | '/_auth/question/download-by-board'
    | '/_auth/question/download-by-class'
    | '/_auth/question/projects'
    | '/_auth/question/subjects'
    | '/_auth/question/upload'
    | '/_auth/reports/app-version-check'
    | '/_auth/settings/feedback-types'
    | '/_auth/settings/institute-types'
    | '/_auth/settings/leave-types'
    | '/_auth/settings/limit-types'
    | '/_auth/settings/web-urls'
    | '/_auth/users/admin'
    | '/_auth/users/agent'
    | '/_auth/users/edit'
    | '/_auth/users/general'
    | '/_auth/users/marketing'
    | '/_auth/users/roles'
    | '/_auth/users/special'
    | '/_auth/users/view'
    | '/_auth/attendance/'
    | '/_auth/users/'
    | '/_auth/dashboards/dcr/$userId'
    | '/_auth/dashboards/system/$userId'
    | '/_auth/feedback/surveys/new'
    | '/_auth/geo-location/mo-travel-history/$userId'
    | '/_auth/hr-form/leave-applications/$applicationId'
    | '/_auth/publish/batches/$batchId'
    | '/_auth/question/monitor/classes'
    | '/_auth/question/monitor/districts'
    | '/_auth/question/papers/$projectInstituteId'
    | '/_auth/settings/institute-submissions/$submissionId'
    | '/_auth/settings/institutes/create'
    | '/_auth/settings/institutes/user-mapping'
    | '/_auth/settings/teacher-submissions/$teacherId'
    | '/_auth/users/create/$category'
    | '/_auth/dashboards/dcr/'
    | '/_auth/dashboards/system/'
    | '/_auth/dashboards/zonal-statement/'
    | '/_auth/feedback/surveys/'
    | '/_auth/geo-location/mo-travel-history/'
    | '/_auth/hr-form/leave-applications/'
    | '/_auth/market-promotion/adjustment/'
    | '/_auth/product/specimen-distribution/'
    | '/_auth/promotion/adjustment/'
    | '/_auth/settings/institute-submissions/'
    | '/_auth/settings/institutes/'
    | '/_auth/settings/teacher-submissions/'
    | '/_auth/dashboards/zonal-statement/$userId/expense'
    | '/_auth/dashboards/zonal-statement/$userId/specimen'
    | '/_auth/feedback/surveys/$surveyId/edit'
    | '/_auth/feedback/surveys/$surveyId/submissions'
    | '/_auth/market-promotion/adjustment/$promoItemId/$zmId'
    | '/_auth/product/specimen-distribution/$specimenId/$zmId'
    | '/_auth/promotion/adjustment/$promoItemId/$zmId'
    | '/_auth/question/monitor/institutes/$projectInstituteId'
    | '/_auth/settings/institutes/$instituteId/edit'
    | '/_auth/feedback/surveys/$surveyId/'
    | '/_auth/market-promotion/adjustment/$promoItemId/'
    | '/_auth/product/specimen-distribution/$specimenId/'
    | '/_auth/promotion/adjustment/$promoItemId/'
    | '/_auth/question/monitor/institutes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  SsoRoute: typeof SsoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sso': {
      id: '/sso'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof SsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/profile': {
      id: '/_auth/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/': {
      id: '/_auth/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthUsersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/attendance/': {
      id: '/_auth/attendance/'
      path: '/attendance'
      fullPath: '/attendance/'
      preLoaderRoute: typeof AuthAttendanceIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/view': {
      id: '/_auth/users/view'
      path: '/users/view'
      fullPath: '/users/view'
      preLoaderRoute: typeof AuthUsersViewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/special': {
      id: '/_auth/users/special'
      path: '/users/special'
      fullPath: '/users/special'
      preLoaderRoute: typeof AuthUsersSpecialRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/roles': {
      id: '/_auth/users/roles'
      path: '/users/roles'
      fullPath: '/users/roles'
      preLoaderRoute: typeof AuthUsersRolesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/marketing': {
      id: '/_auth/users/marketing'
      path: '/users/marketing'
      fullPath: '/users/marketing'
      preLoaderRoute: typeof AuthUsersMarketingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/general': {
      id: '/_auth/users/general'
      path: '/users/general'
      fullPath: '/users/general'
      preLoaderRoute: typeof AuthUsersGeneralRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/edit': {
      id: '/_auth/users/edit'
      path: '/users/edit'
      fullPath: '/users/edit'
      preLoaderRoute: typeof AuthUsersEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/agent': {
      id: '/_auth/users/agent'
      path: '/users/agent'
      fullPath: '/users/agent'
      preLoaderRoute: typeof AuthUsersAgentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/admin': {
      id: '/_auth/users/admin'
      path: '/users/admin'
      fullPath: '/users/admin'
      preLoaderRoute: typeof AuthUsersAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/web-urls': {
      id: '/_auth/settings/web-urls'
      path: '/settings/web-urls'
      fullPath: '/settings/web-urls'
      preLoaderRoute: typeof AuthSettingsWebUrlsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/limit-types': {
      id: '/_auth/settings/limit-types'
      path: '/settings/limit-types'
      fullPath: '/settings/limit-types'
      preLoaderRoute: typeof AuthSettingsLimitTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/leave-types': {
      id: '/_auth/settings/leave-types'
      path: '/settings/leave-types'
      fullPath: '/settings/leave-types'
      preLoaderRoute: typeof AuthSettingsLeaveTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institute-types': {
      id: '/_auth/settings/institute-types'
      path: '/settings/institute-types'
      fullPath: '/settings/institute-types'
      preLoaderRoute: typeof AuthSettingsInstituteTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/feedback-types': {
      id: '/_auth/settings/feedback-types'
      path: '/settings/feedback-types'
      fullPath: '/settings/feedback-types'
      preLoaderRoute: typeof AuthSettingsFeedbackTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reports/app-version-check': {
      id: '/_auth/reports/app-version-check'
      path: '/reports/app-version-check'
      fullPath: '/reports/app-version-check'
      preLoaderRoute: typeof AuthReportsAppVersionCheckRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/upload': {
      id: '/_auth/question/upload'
      path: '/question/upload'
      fullPath: '/question/upload'
      preLoaderRoute: typeof AuthQuestionUploadRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/subjects': {
      id: '/_auth/question/subjects'
      path: '/question/subjects'
      fullPath: '/question/subjects'
      preLoaderRoute: typeof AuthQuestionSubjectsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/projects': {
      id: '/_auth/question/projects'
      path: '/question/projects'
      fullPath: '/question/projects'
      preLoaderRoute: typeof AuthQuestionProjectsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/download-by-class': {
      id: '/_auth/question/download-by-class'
      path: '/question/download-by-class'
      fullPath: '/question/download-by-class'
      preLoaderRoute: typeof AuthQuestionDownloadByClassRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/download-by-board': {
      id: '/_auth/question/download-by-board'
      path: '/question/download-by-board'
      fullPath: '/question/download-by-board'
      preLoaderRoute: typeof AuthQuestionDownloadByBoardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/download': {
      id: '/_auth/question/download'
      path: '/question/download'
      fullPath: '/question/download'
      preLoaderRoute: typeof AuthQuestionDownloadRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/publish/sales': {
      id: '/_auth/publish/sales'
      path: '/publish/sales'
      fullPath: '/publish/sales'
      preLoaderRoute: typeof AuthPublishSalesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/publish/mis': {
      id: '/_auth/publish/mis'
      path: '/publish/mis'
      fullPath: '/publish/mis'
      preLoaderRoute: typeof AuthPublishMisRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/publish/accounts': {
      id: '/_auth/publish/accounts'
      path: '/publish/accounts'
      fullPath: '/publish/accounts'
      preLoaderRoute: typeof AuthPublishAccountsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/items': {
      id: '/_auth/promotion/items'
      path: '/promotion/items'
      fullPath: '/promotion/items'
      preLoaderRoute: typeof AuthPromotionItemsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/item-types': {
      id: '/_auth/promotion/item-types'
      path: '/promotion/item-types'
      fullPath: '/promotion/item-types'
      preLoaderRoute: typeof AuthPromotionItemTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/distribution': {
      id: '/_auth/promotion/distribution'
      path: '/promotion/distribution'
      fullPath: '/promotion/distribution'
      preLoaderRoute: typeof AuthPromotionDistributionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimens': {
      id: '/_auth/product/specimens'
      path: '/product/specimens'
      fullPath: '/product/specimens'
      preLoaderRoute: typeof AuthProductSpecimensRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-list-view': {
      id: '/_auth/product/specimen-list-view'
      path: '/product/specimen-list-view'
      fullPath: '/product/specimen-list-view'
      preLoaderRoute: typeof AuthProductSpecimenListViewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-institution': {
      id: '/_auth/product/specimen-institution'
      path: '/product/specimen-institution'
      fullPath: '/product/specimen-institution'
      preLoaderRoute: typeof AuthProductSpecimenInstitutionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-adjustment': {
      id: '/_auth/product/specimen-adjustment'
      path: '/product/specimen-adjustment'
      fullPath: '/product/specimen-adjustment'
      preLoaderRoute: typeof AuthProductSpecimenAdjustmentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/dcr-sheet': {
      id: '/_auth/product/dcr-sheet'
      path: '/product/dcr-sheet'
      fullPath: '/product/dcr-sheet'
      preLoaderRoute: typeof AuthProductDcrSheetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/dcr-date-to-date': {
      id: '/_auth/product/dcr-date-to-date'
      path: '/product/dcr-date-to-date'
      fullPath: '/product/dcr-date-to-date'
      preLoaderRoute: typeof AuthProductDcrDateToDateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/book-types': {
      id: '/_auth/product/book-types'
      path: '/product/book-types'
      fullPath: '/product/book-types'
      preLoaderRoute: typeof AuthProductBookTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/book-editions': {
      id: '/_auth/product/book-editions'
      path: '/product/book-editions'
      fullPath: '/product/book-editions'
      preLoaderRoute: typeof AuthProductBookEditionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/requisitions': {
      id: '/_auth/market-promotion/requisitions'
      path: '/market-promotion/requisitions'
      fullPath: '/market-promotion/requisitions'
      preLoaderRoute: typeof AuthMarketPromotionRequisitionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/region-summary': {
      id: '/_auth/market-promotion/region-summary'
      path: '/market-promotion/region-summary'
      fullPath: '/market-promotion/region-summary'
      preLoaderRoute: typeof AuthMarketPromotionRegionSummaryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/publish-panel': {
      id: '/_auth/market-promotion/publish-panel'
      path: '/market-promotion/publish-panel'
      fullPath: '/market-promotion/publish-panel'
      preLoaderRoute: typeof AuthMarketPromotionPublishPanelRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/projects': {
      id: '/_auth/market-promotion/projects'
      path: '/market-promotion/projects'
      fullPath: '/market-promotion/projects'
      preLoaderRoute: typeof AuthMarketPromotionProjectsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/mis-approvals': {
      id: '/_auth/market-promotion/mis-approvals'
      path: '/market-promotion/mis-approvals'
      fullPath: '/market-promotion/mis-approvals'
      preLoaderRoute: typeof AuthMarketPromotionMisApprovalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/distribution-summary': {
      id: '/_auth/market-promotion/distribution-summary'
      path: '/market-promotion/distribution-summary'
      fullPath: '/market-promotion/distribution-summary'
      preLoaderRoute: typeof AuthMarketPromotionDistributionSummaryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/cash-collection': {
      id: '/_auth/market-promotion/cash-collection'
      path: '/market-promotion/cash-collection'
      fullPath: '/market-promotion/cash-collection'
      preLoaderRoute: typeof AuthMarketPromotionCashCollectionRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/budget-entry': {
      id: '/_auth/market-promotion/budget-entry'
      path: '/market-promotion/budget-entry'
      fullPath: '/market-promotion/budget-entry'
      preLoaderRoute: typeof AuthMarketPromotionBudgetEntryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/approvals': {
      id: '/_auth/market-promotion/approvals'
      path: '/market-promotion/approvals'
      fullPath: '/market-promotion/approvals'
      preLoaderRoute: typeof AuthMarketPromotionApprovalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/approval-report': {
      id: '/_auth/market-promotion/approval-report'
      path: '/market-promotion/approval-report'
      fullPath: '/market-promotion/approval-report'
      preLoaderRoute: typeof AuthMarketPromotionApprovalReportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/accounts-adjust': {
      id: '/_auth/market-promotion/accounts-adjust'
      path: '/market-promotion/accounts-adjust'
      fullPath: '/market-promotion/accounts-adjust'
      preLoaderRoute: typeof AuthMarketPromotionAccountsAdjustRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/hr-form/leave-report': {
      id: '/_auth/hr-form/leave-report'
      path: '/hr-form/leave-report'
      fullPath: '/hr-form/leave-report'
      preLoaderRoute: typeof AuthHrFormLeaveReportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/types': {
      id: '/_auth/feedback/types'
      path: '/feedback/types'
      fullPath: '/feedback/types'
      preLoaderRoute: typeof AuthFeedbackTypesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/list': {
      id: '/_auth/feedback/list'
      path: '/feedback/list'
      fullPath: '/feedback/list'
      preLoaderRoute: typeof AuthFeedbackListRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/pending': {
      id: '/_auth/dashboards/pending'
      path: '/dashboards/pending'
      fullPath: '/dashboards/pending'
      preLoaderRoute: typeof AuthDashboardsPendingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/der': {
      id: '/_auth/dashboards/der'
      path: '/dashboards/der'
      fullPath: '/dashboards/der'
      preLoaderRoute: typeof AuthDashboardsDerRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/web-expense': {
      id: '/_auth/billing/web-expense'
      path: '/billing/web-expense'
      fullPath: '/billing/web-expense'
      preLoaderRoute: typeof AuthBillingWebExpenseRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/offline-der-verify': {
      id: '/_auth/billing/offline-der-verify'
      path: '/billing/offline-der-verify'
      fullPath: '/billing/offline-der-verify'
      preLoaderRoute: typeof AuthBillingOfflineDerVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/offline-dcr-verify': {
      id: '/_auth/billing/offline-dcr-verify'
      path: '/billing/offline-dcr-verify'
      fullPath: '/billing/offline-dcr-verify'
      preLoaderRoute: typeof AuthBillingOfflineDcrVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/expense-approve': {
      id: '/_auth/billing/expense-approve'
      path: '/billing/expense-approve'
      fullPath: '/billing/expense-approve'
      preLoaderRoute: typeof AuthBillingExpenseApproveRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/dcr-approve': {
      id: '/_auth/billing/dcr-approve'
      path: '/billing/dcr-approve'
      fullPath: '/billing/dcr-approve'
      preLoaderRoute: typeof AuthBillingDcrApproveRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/cost-amendment': {
      id: '/_auth/billing/cost-amendment'
      path: '/billing/cost-amendment'
      fullPath: '/billing/cost-amendment'
      preLoaderRoute: typeof AuthBillingCostAmendmentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/approval': {
      id: '/_auth/billing/approval'
      path: '/billing/approval'
      fullPath: '/billing/approval'
      preLoaderRoute: typeof AuthBillingApprovalRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing/all-cost': {
      id: '/_auth/billing/all-cost'
      path: '/billing/all-cost'
      fullPath: '/billing/all-cost'
      preLoaderRoute: typeof AuthBillingAllCostRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/attendance/shift-job-card': {
      id: '/_auth/attendance/shift-job-card'
      path: '/attendance/shift-job-card'
      fullPath: '/attendance/shift-job-card'
      preLoaderRoute: typeof AuthAttendanceShiftJobCardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/attendance/shift-employee-report': {
      id: '/_auth/attendance/shift-employee-report'
      path: '/attendance/shift-employee-report'
      fullPath: '/attendance/shift-employee-report'
      preLoaderRoute: typeof AuthAttendanceShiftEmployeeReportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/attendance/job-card': {
      id: '/_auth/attendance/job-card'
      path: '/attendance/job-card'
      fullPath: '/attendance/job-card'
      preLoaderRoute: typeof AuthAttendanceJobCardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/attendance/employee-report': {
      id: '/_auth/attendance/employee-report'
      path: '/attendance/employee-report'
      fullPath: '/attendance/employee-report'
      preLoaderRoute: typeof AuthAttendanceEmployeeReportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/teacher-submissions/': {
      id: '/_auth/settings/teacher-submissions/'
      path: '/settings/teacher-submissions'
      fullPath: '/settings/teacher-submissions/'
      preLoaderRoute: typeof AuthSettingsTeacherSubmissionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institutes/': {
      id: '/_auth/settings/institutes/'
      path: '/settings/institutes'
      fullPath: '/settings/institutes/'
      preLoaderRoute: typeof AuthSettingsInstitutesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institute-submissions/': {
      id: '/_auth/settings/institute-submissions/'
      path: '/settings/institute-submissions'
      fullPath: '/settings/institute-submissions/'
      preLoaderRoute: typeof AuthSettingsInstituteSubmissionsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/adjustment/': {
      id: '/_auth/promotion/adjustment/'
      path: '/promotion/adjustment'
      fullPath: '/promotion/adjustment/'
      preLoaderRoute: typeof AuthPromotionAdjustmentIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-distribution/': {
      id: '/_auth/product/specimen-distribution/'
      path: '/product/specimen-distribution'
      fullPath: '/product/specimen-distribution/'
      preLoaderRoute: typeof AuthProductSpecimenDistributionIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/adjustment/': {
      id: '/_auth/market-promotion/adjustment/'
      path: '/market-promotion/adjustment'
      fullPath: '/market-promotion/adjustment/'
      preLoaderRoute: typeof AuthMarketPromotionAdjustmentIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/hr-form/leave-applications/': {
      id: '/_auth/hr-form/leave-applications/'
      path: '/hr-form/leave-applications'
      fullPath: '/hr-form/leave-applications/'
      preLoaderRoute: typeof AuthHrFormLeaveApplicationsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/geo-location/mo-travel-history/': {
      id: '/_auth/geo-location/mo-travel-history/'
      path: '/geo-location/mo-travel-history'
      fullPath: '/geo-location/mo-travel-history/'
      preLoaderRoute: typeof AuthGeoLocationMoTravelHistoryIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/surveys/': {
      id: '/_auth/feedback/surveys/'
      path: '/feedback/surveys'
      fullPath: '/feedback/surveys/'
      preLoaderRoute: typeof AuthFeedbackSurveysIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/zonal-statement/': {
      id: '/_auth/dashboards/zonal-statement/'
      path: '/dashboards/zonal-statement'
      fullPath: '/dashboards/zonal-statement/'
      preLoaderRoute: typeof AuthDashboardsZonalStatementIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/system/': {
      id: '/_auth/dashboards/system/'
      path: '/dashboards/system'
      fullPath: '/dashboards/system/'
      preLoaderRoute: typeof AuthDashboardsSystemIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/dcr/': {
      id: '/_auth/dashboards/dcr/'
      path: '/dashboards/dcr'
      fullPath: '/dashboards/dcr/'
      preLoaderRoute: typeof AuthDashboardsDcrIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/users/create/$category': {
      id: '/_auth/users/create/$category'
      path: '/users/create/$category'
      fullPath: '/users/create/$category'
      preLoaderRoute: typeof AuthUsersCreateCategoryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/teacher-submissions/$teacherId': {
      id: '/_auth/settings/teacher-submissions/$teacherId'
      path: '/settings/teacher-submissions/$teacherId'
      fullPath: '/settings/teacher-submissions/$teacherId'
      preLoaderRoute: typeof AuthSettingsTeacherSubmissionsTeacherIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institutes/user-mapping': {
      id: '/_auth/settings/institutes/user-mapping'
      path: '/settings/institutes/user-mapping'
      fullPath: '/settings/institutes/user-mapping'
      preLoaderRoute: typeof AuthSettingsInstitutesUserMappingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institutes/create': {
      id: '/_auth/settings/institutes/create'
      path: '/settings/institutes/create'
      fullPath: '/settings/institutes/create'
      preLoaderRoute: typeof AuthSettingsInstitutesCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institute-submissions/$submissionId': {
      id: '/_auth/settings/institute-submissions/$submissionId'
      path: '/settings/institute-submissions/$submissionId'
      fullPath: '/settings/institute-submissions/$submissionId'
      preLoaderRoute: typeof AuthSettingsInstituteSubmissionsSubmissionIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/papers/$projectInstituteId': {
      id: '/_auth/question/papers/$projectInstituteId'
      path: '/question/papers/$projectInstituteId'
      fullPath: '/question/papers/$projectInstituteId'
      preLoaderRoute: typeof AuthQuestionPapersProjectInstituteIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/monitor/districts': {
      id: '/_auth/question/monitor/districts'
      path: '/question/monitor/districts'
      fullPath: '/question/monitor/districts'
      preLoaderRoute: typeof AuthQuestionMonitorDistrictsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/monitor/classes': {
      id: '/_auth/question/monitor/classes'
      path: '/question/monitor/classes'
      fullPath: '/question/monitor/classes'
      preLoaderRoute: typeof AuthQuestionMonitorClassesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/publish/batches/$batchId': {
      id: '/_auth/publish/batches/$batchId'
      path: '/publish/batches/$batchId'
      fullPath: '/publish/batches/$batchId'
      preLoaderRoute: typeof AuthPublishBatchesBatchIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/hr-form/leave-applications/$applicationId': {
      id: '/_auth/hr-form/leave-applications/$applicationId'
      path: '/hr-form/leave-applications/$applicationId'
      fullPath: '/hr-form/leave-applications/$applicationId'
      preLoaderRoute: typeof AuthHrFormLeaveApplicationsApplicationIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/geo-location/mo-travel-history/$userId': {
      id: '/_auth/geo-location/mo-travel-history/$userId'
      path: '/geo-location/mo-travel-history/$userId'
      fullPath: '/geo-location/mo-travel-history/$userId'
      preLoaderRoute: typeof AuthGeoLocationMoTravelHistoryUserIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/surveys/new': {
      id: '/_auth/feedback/surveys/new'
      path: '/feedback/surveys/new'
      fullPath: '/feedback/surveys/new'
      preLoaderRoute: typeof AuthFeedbackSurveysNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/system/$userId': {
      id: '/_auth/dashboards/system/$userId'
      path: '/dashboards/system/$userId'
      fullPath: '/dashboards/system/$userId'
      preLoaderRoute: typeof AuthDashboardsSystemUserIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/dcr/$userId': {
      id: '/_auth/dashboards/dcr/$userId'
      path: '/dashboards/dcr/$userId'
      fullPath: '/dashboards/dcr/$userId'
      preLoaderRoute: typeof AuthDashboardsDcrUserIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/monitor/institutes/': {
      id: '/_auth/question/monitor/institutes/'
      path: '/question/monitor/institutes'
      fullPath: '/question/monitor/institutes/'
      preLoaderRoute: typeof AuthQuestionMonitorInstitutesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/adjustment/$promoItemId/': {
      id: '/_auth/promotion/adjustment/$promoItemId/'
      path: '/promotion/adjustment/$promoItemId'
      fullPath: '/promotion/adjustment/$promoItemId/'
      preLoaderRoute: typeof AuthPromotionAdjustmentPromoItemIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-distribution/$specimenId/': {
      id: '/_auth/product/specimen-distribution/$specimenId/'
      path: '/product/specimen-distribution/$specimenId'
      fullPath: '/product/specimen-distribution/$specimenId/'
      preLoaderRoute: typeof AuthProductSpecimenDistributionSpecimenIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/adjustment/$promoItemId/': {
      id: '/_auth/market-promotion/adjustment/$promoItemId/'
      path: '/market-promotion/adjustment/$promoItemId'
      fullPath: '/market-promotion/adjustment/$promoItemId/'
      preLoaderRoute: typeof AuthMarketPromotionAdjustmentPromoItemIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/surveys/$surveyId/': {
      id: '/_auth/feedback/surveys/$surveyId/'
      path: '/feedback/surveys/$surveyId'
      fullPath: '/feedback/surveys/$surveyId/'
      preLoaderRoute: typeof AuthFeedbackSurveysSurveyIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/institutes/$instituteId/edit': {
      id: '/_auth/settings/institutes/$instituteId/edit'
      path: '/settings/institutes/$instituteId/edit'
      fullPath: '/settings/institutes/$instituteId/edit'
      preLoaderRoute: typeof AuthSettingsInstitutesInstituteIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/question/monitor/institutes/$projectInstituteId': {
      id: '/_auth/question/monitor/institutes/$projectInstituteId'
      path: '/question/monitor/institutes/$projectInstituteId'
      fullPath: '/question/monitor/institutes/$projectInstituteId'
      preLoaderRoute: typeof AuthQuestionMonitorInstitutesProjectInstituteIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/promotion/adjustment/$promoItemId/$zmId': {
      id: '/_auth/promotion/adjustment/$promoItemId/$zmId'
      path: '/promotion/adjustment/$promoItemId/$zmId'
      fullPath: '/promotion/adjustment/$promoItemId/$zmId'
      preLoaderRoute: typeof AuthPromotionAdjustmentPromoItemIdZmIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product/specimen-distribution/$specimenId/$zmId': {
      id: '/_auth/product/specimen-distribution/$specimenId/$zmId'
      path: '/product/specimen-distribution/$specimenId/$zmId'
      fullPath: '/product/specimen-distribution/$specimenId/$zmId'
      preLoaderRoute: typeof AuthProductSpecimenDistributionSpecimenIdZmIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/market-promotion/adjustment/$promoItemId/$zmId': {
      id: '/_auth/market-promotion/adjustment/$promoItemId/$zmId'
      path: '/market-promotion/adjustment/$promoItemId/$zmId'
      fullPath: '/market-promotion/adjustment/$promoItemId/$zmId'
      preLoaderRoute: typeof AuthMarketPromotionAdjustmentPromoItemIdZmIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/surveys/$surveyId/submissions': {
      id: '/_auth/feedback/surveys/$surveyId/submissions'
      path: '/feedback/surveys/$surveyId/submissions'
      fullPath: '/feedback/surveys/$surveyId/submissions'
      preLoaderRoute: typeof AuthFeedbackSurveysSurveyIdSubmissionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/feedback/surveys/$surveyId/edit': {
      id: '/_auth/feedback/surveys/$surveyId/edit'
      path: '/feedback/surveys/$surveyId/edit'
      fullPath: '/feedback/surveys/$surveyId/edit'
      preLoaderRoute: typeof AuthFeedbackSurveysSurveyIdEditRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/zonal-statement/$userId/specimen': {
      id: '/_auth/dashboards/zonal-statement/$userId/specimen'
      path: '/dashboards/zonal-statement/$userId/specimen'
      fullPath: '/dashboards/zonal-statement/$userId/specimen'
      preLoaderRoute: typeof AuthDashboardsZonalStatementUserIdSpecimenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboards/zonal-statement/$userId/expense': {
      id: '/_auth/dashboards/zonal-statement/$userId/expense'
      path: '/dashboards/zonal-statement/$userId/expense'
      fullPath: '/dashboards/zonal-statement/$userId/expense'
      preLoaderRoute: typeof AuthDashboardsZonalStatementUserIdExpenseRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthProfileRoute: typeof AuthProfileRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAttendanceEmployeeReportRoute: typeof AuthAttendanceEmployeeReportRoute
  AuthAttendanceJobCardRoute: typeof AuthAttendanceJobCardRoute
  AuthAttendanceShiftEmployeeReportRoute: typeof AuthAttendanceShiftEmployeeReportRoute
  AuthAttendanceShiftJobCardRoute: typeof AuthAttendanceShiftJobCardRoute
  AuthBillingAllCostRoute: typeof AuthBillingAllCostRoute
  AuthBillingApprovalRoute: typeof AuthBillingApprovalRoute
  AuthBillingCostAmendmentRoute: typeof AuthBillingCostAmendmentRoute
  AuthBillingDcrApproveRoute: typeof AuthBillingDcrApproveRoute
  AuthBillingExpenseApproveRoute: typeof AuthBillingExpenseApproveRoute
  AuthBillingOfflineDcrVerifyRoute: typeof AuthBillingOfflineDcrVerifyRoute
  AuthBillingOfflineDerVerifyRoute: typeof AuthBillingOfflineDerVerifyRoute
  AuthBillingWebExpenseRoute: typeof AuthBillingWebExpenseRoute
  AuthDashboardsDerRoute: typeof AuthDashboardsDerRoute
  AuthDashboardsPendingRoute: typeof AuthDashboardsPendingRoute
  AuthFeedbackListRoute: typeof AuthFeedbackListRoute
  AuthFeedbackTypesRoute: typeof AuthFeedbackTypesRoute
  AuthHrFormLeaveReportRoute: typeof AuthHrFormLeaveReportRoute
  AuthMarketPromotionAccountsAdjustRoute: typeof AuthMarketPromotionAccountsAdjustRoute
  AuthMarketPromotionApprovalReportRoute: typeof AuthMarketPromotionApprovalReportRoute
  AuthMarketPromotionApprovalsRoute: typeof AuthMarketPromotionApprovalsRoute
  AuthMarketPromotionBudgetEntryRoute: typeof AuthMarketPromotionBudgetEntryRoute
  AuthMarketPromotionCashCollectionRoute: typeof AuthMarketPromotionCashCollectionRoute
  AuthMarketPromotionDistributionSummaryRoute: typeof AuthMarketPromotionDistributionSummaryRoute
  AuthMarketPromotionMisApprovalsRoute: typeof AuthMarketPromotionMisApprovalsRoute
  AuthMarketPromotionProjectsRoute: typeof AuthMarketPromotionProjectsRoute
  AuthMarketPromotionPublishPanelRoute: typeof AuthMarketPromotionPublishPanelRoute
  AuthMarketPromotionRegionSummaryRoute: typeof AuthMarketPromotionRegionSummaryRoute
  AuthMarketPromotionRequisitionsRoute: typeof AuthMarketPromotionRequisitionsRoute
  AuthProductBookEditionsRoute: typeof AuthProductBookEditionsRoute
  AuthProductBookTypesRoute: typeof AuthProductBookTypesRoute
  AuthProductDcrDateToDateRoute: typeof AuthProductDcrDateToDateRoute
  AuthProductDcrSheetRoute: typeof AuthProductDcrSheetRoute
  AuthProductSpecimenAdjustmentRoute: typeof AuthProductSpecimenAdjustmentRoute
  AuthProductSpecimenInstitutionRoute: typeof AuthProductSpecimenInstitutionRoute
  AuthProductSpecimenListViewRoute: typeof AuthProductSpecimenListViewRoute
  AuthProductSpecimensRoute: typeof AuthProductSpecimensRoute
  AuthPromotionDistributionRoute: typeof AuthPromotionDistributionRoute
  AuthPromotionItemTypesRoute: typeof AuthPromotionItemTypesRoute
  AuthPromotionItemsRoute: typeof AuthPromotionItemsRoute
  AuthPublishAccountsRoute: typeof AuthPublishAccountsRoute
  AuthPublishMisRoute: typeof AuthPublishMisRoute
  AuthPublishSalesRoute: typeof AuthPublishSalesRoute
  AuthQuestionDownloadRoute: typeof AuthQuestionDownloadRoute
  AuthQuestionDownloadByBoardRoute: typeof AuthQuestionDownloadByBoardRoute
  AuthQuestionDownloadByClassRoute: typeof AuthQuestionDownloadByClassRoute
  AuthQuestionProjectsRoute: typeof AuthQuestionProjectsRoute
  AuthQuestionSubjectsRoute: typeof AuthQuestionSubjectsRoute
  AuthQuestionUploadRoute: typeof AuthQuestionUploadRoute
  AuthReportsAppVersionCheckRoute: typeof AuthReportsAppVersionCheckRoute
  AuthSettingsFeedbackTypesRoute: typeof AuthSettingsFeedbackTypesRoute
  AuthSettingsInstituteTypesRoute: typeof AuthSettingsInstituteTypesRoute
  AuthSettingsLeaveTypesRoute: typeof AuthSettingsLeaveTypesRoute
  AuthSettingsLimitTypesRoute: typeof AuthSettingsLimitTypesRoute
  AuthSettingsWebUrlsRoute: typeof AuthSettingsWebUrlsRoute
  AuthUsersAdminRoute: typeof AuthUsersAdminRoute
  AuthUsersAgentRoute: typeof AuthUsersAgentRoute
  AuthUsersEditRoute: typeof AuthUsersEditRoute
  AuthUsersGeneralRoute: typeof AuthUsersGeneralRoute
  AuthUsersMarketingRoute: typeof AuthUsersMarketingRoute
  AuthUsersRolesRoute: typeof AuthUsersRolesRoute
  AuthUsersSpecialRoute: typeof AuthUsersSpecialRoute
  AuthUsersViewRoute: typeof AuthUsersViewRoute
  AuthAttendanceIndexRoute: typeof AuthAttendanceIndexRoute
  AuthUsersIndexRoute: typeof AuthUsersIndexRoute
  AuthDashboardsDcrUserIdRoute: typeof AuthDashboardsDcrUserIdRoute
  AuthDashboardsSystemUserIdRoute: typeof AuthDashboardsSystemUserIdRoute
  AuthFeedbackSurveysNewRoute: typeof AuthFeedbackSurveysNewRoute
  AuthGeoLocationMoTravelHistoryUserIdRoute: typeof AuthGeoLocationMoTravelHistoryUserIdRoute
  AuthHrFormLeaveApplicationsApplicationIdRoute: typeof AuthHrFormLeaveApplicationsApplicationIdRoute
  AuthPublishBatchesBatchIdRoute: typeof AuthPublishBatchesBatchIdRoute
  AuthQuestionMonitorClassesRoute: typeof AuthQuestionMonitorClassesRoute
  AuthQuestionMonitorDistrictsRoute: typeof AuthQuestionMonitorDistrictsRoute
  AuthQuestionPapersProjectInstituteIdRoute: typeof AuthQuestionPapersProjectInstituteIdRoute
  AuthSettingsInstituteSubmissionsSubmissionIdRoute: typeof AuthSettingsInstituteSubmissionsSubmissionIdRoute
  AuthSettingsInstitutesCreateRoute: typeof AuthSettingsInstitutesCreateRoute
  AuthSettingsInstitutesUserMappingRoute: typeof AuthSettingsInstitutesUserMappingRoute
  AuthSettingsTeacherSubmissionsTeacherIdRoute: typeof AuthSettingsTeacherSubmissionsTeacherIdRoute
  AuthUsersCreateCategoryRoute: typeof AuthUsersCreateCategoryRoute
  AuthDashboardsDcrIndexRoute: typeof AuthDashboardsDcrIndexRoute
  AuthDashboardsSystemIndexRoute: typeof AuthDashboardsSystemIndexRoute
  AuthDashboardsZonalStatementIndexRoute: typeof AuthDashboardsZonalStatementIndexRoute
  AuthFeedbackSurveysIndexRoute: typeof AuthFeedbackSurveysIndexRoute
  AuthGeoLocationMoTravelHistoryIndexRoute: typeof AuthGeoLocationMoTravelHistoryIndexRoute
  AuthHrFormLeaveApplicationsIndexRoute: typeof AuthHrFormLeaveApplicationsIndexRoute
  AuthMarketPromotionAdjustmentIndexRoute: typeof AuthMarketPromotionAdjustmentIndexRoute
  AuthProductSpecimenDistributionIndexRoute: typeof AuthProductSpecimenDistributionIndexRoute
  AuthPromotionAdjustmentIndexRoute: typeof AuthPromotionAdjustmentIndexRoute
  AuthSettingsInstituteSubmissionsIndexRoute: typeof AuthSettingsInstituteSubmissionsIndexRoute
  AuthSettingsInstitutesIndexRoute: typeof AuthSettingsInstitutesIndexRoute
  AuthSettingsTeacherSubmissionsIndexRoute: typeof AuthSettingsTeacherSubmissionsIndexRoute
  AuthDashboardsZonalStatementUserIdExpenseRoute: typeof AuthDashboardsZonalStatementUserIdExpenseRoute
  AuthDashboardsZonalStatementUserIdSpecimenRoute: typeof AuthDashboardsZonalStatementUserIdSpecimenRoute
  AuthFeedbackSurveysSurveyIdEditRoute: typeof AuthFeedbackSurveysSurveyIdEditRoute
  AuthFeedbackSurveysSurveyIdSubmissionsRoute: typeof AuthFeedbackSurveysSurveyIdSubmissionsRoute
  AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute: typeof AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute
  AuthProductSpecimenDistributionSpecimenIdZmIdRoute: typeof AuthProductSpecimenDistributionSpecimenIdZmIdRoute
  AuthPromotionAdjustmentPromoItemIdZmIdRoute: typeof AuthPromotionAdjustmentPromoItemIdZmIdRoute
  AuthQuestionMonitorInstitutesProjectInstituteIdRoute: typeof AuthQuestionMonitorInstitutesProjectInstituteIdRoute
  AuthSettingsInstitutesInstituteIdEditRoute: typeof AuthSettingsInstitutesInstituteIdEditRoute
  AuthFeedbackSurveysSurveyIdIndexRoute: typeof AuthFeedbackSurveysSurveyIdIndexRoute
  AuthMarketPromotionAdjustmentPromoItemIdIndexRoute: typeof AuthMarketPromotionAdjustmentPromoItemIdIndexRoute
  AuthProductSpecimenDistributionSpecimenIdIndexRoute: typeof AuthProductSpecimenDistributionSpecimenIdIndexRoute
  AuthPromotionAdjustmentPromoItemIdIndexRoute: typeof AuthPromotionAdjustmentPromoItemIdIndexRoute
  AuthQuestionMonitorInstitutesIndexRoute: typeof AuthQuestionMonitorInstitutesIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthProfileRoute: AuthProfileRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAttendanceEmployeeReportRoute: AuthAttendanceEmployeeReportRoute,
  AuthAttendanceJobCardRoute: AuthAttendanceJobCardRoute,
  AuthAttendanceShiftEmployeeReportRoute:
    AuthAttendanceShiftEmployeeReportRoute,
  AuthAttendanceShiftJobCardRoute: AuthAttendanceShiftJobCardRoute,
  AuthBillingAllCostRoute: AuthBillingAllCostRoute,
  AuthBillingApprovalRoute: AuthBillingApprovalRoute,
  AuthBillingCostAmendmentRoute: AuthBillingCostAmendmentRoute,
  AuthBillingDcrApproveRoute: AuthBillingDcrApproveRoute,
  AuthBillingExpenseApproveRoute: AuthBillingExpenseApproveRoute,
  AuthBillingOfflineDcrVerifyRoute: AuthBillingOfflineDcrVerifyRoute,
  AuthBillingOfflineDerVerifyRoute: AuthBillingOfflineDerVerifyRoute,
  AuthBillingWebExpenseRoute: AuthBillingWebExpenseRoute,
  AuthDashboardsDerRoute: AuthDashboardsDerRoute,
  AuthDashboardsPendingRoute: AuthDashboardsPendingRoute,
  AuthFeedbackListRoute: AuthFeedbackListRoute,
  AuthFeedbackTypesRoute: AuthFeedbackTypesRoute,
  AuthHrFormLeaveReportRoute: AuthHrFormLeaveReportRoute,
  AuthMarketPromotionAccountsAdjustRoute:
    AuthMarketPromotionAccountsAdjustRoute,
  AuthMarketPromotionApprovalReportRoute:
    AuthMarketPromotionApprovalReportRoute,
  AuthMarketPromotionApprovalsRoute: AuthMarketPromotionApprovalsRoute,
  AuthMarketPromotionBudgetEntryRoute: AuthMarketPromotionBudgetEntryRoute,
  AuthMarketPromotionCashCollectionRoute:
    AuthMarketPromotionCashCollectionRoute,
  AuthMarketPromotionDistributionSummaryRoute:
    AuthMarketPromotionDistributionSummaryRoute,
  AuthMarketPromotionMisApprovalsRoute: AuthMarketPromotionMisApprovalsRoute,
  AuthMarketPromotionProjectsRoute: AuthMarketPromotionProjectsRoute,
  AuthMarketPromotionPublishPanelRoute: AuthMarketPromotionPublishPanelRoute,
  AuthMarketPromotionRegionSummaryRoute: AuthMarketPromotionRegionSummaryRoute,
  AuthMarketPromotionRequisitionsRoute: AuthMarketPromotionRequisitionsRoute,
  AuthProductBookEditionsRoute: AuthProductBookEditionsRoute,
  AuthProductBookTypesRoute: AuthProductBookTypesRoute,
  AuthProductDcrDateToDateRoute: AuthProductDcrDateToDateRoute,
  AuthProductDcrSheetRoute: AuthProductDcrSheetRoute,
  AuthProductSpecimenAdjustmentRoute: AuthProductSpecimenAdjustmentRoute,
  AuthProductSpecimenInstitutionRoute: AuthProductSpecimenInstitutionRoute,
  AuthProductSpecimenListViewRoute: AuthProductSpecimenListViewRoute,
  AuthProductSpecimensRoute: AuthProductSpecimensRoute,
  AuthPromotionDistributionRoute: AuthPromotionDistributionRoute,
  AuthPromotionItemTypesRoute: AuthPromotionItemTypesRoute,
  AuthPromotionItemsRoute: AuthPromotionItemsRoute,
  AuthPublishAccountsRoute: AuthPublishAccountsRoute,
  AuthPublishMisRoute: AuthPublishMisRoute,
  AuthPublishSalesRoute: AuthPublishSalesRoute,
  AuthQuestionDownloadRoute: AuthQuestionDownloadRoute,
  AuthQuestionDownloadByBoardRoute: AuthQuestionDownloadByBoardRoute,
  AuthQuestionDownloadByClassRoute: AuthQuestionDownloadByClassRoute,
  AuthQuestionProjectsRoute: AuthQuestionProjectsRoute,
  AuthQuestionSubjectsRoute: AuthQuestionSubjectsRoute,
  AuthQuestionUploadRoute: AuthQuestionUploadRoute,
  AuthReportsAppVersionCheckRoute: AuthReportsAppVersionCheckRoute,
  AuthSettingsFeedbackTypesRoute: AuthSettingsFeedbackTypesRoute,
  AuthSettingsInstituteTypesRoute: AuthSettingsInstituteTypesRoute,
  AuthSettingsLeaveTypesRoute: AuthSettingsLeaveTypesRoute,
  AuthSettingsLimitTypesRoute: AuthSettingsLimitTypesRoute,
  AuthSettingsWebUrlsRoute: AuthSettingsWebUrlsRoute,
  AuthUsersAdminRoute: AuthUsersAdminRoute,
  AuthUsersAgentRoute: AuthUsersAgentRoute,
  AuthUsersEditRoute: AuthUsersEditRoute,
  AuthUsersGeneralRoute: AuthUsersGeneralRoute,
  AuthUsersMarketingRoute: AuthUsersMarketingRoute,
  AuthUsersRolesRoute: AuthUsersRolesRoute,
  AuthUsersSpecialRoute: AuthUsersSpecialRoute,
  AuthUsersViewRoute: AuthUsersViewRoute,
  AuthAttendanceIndexRoute: AuthAttendanceIndexRoute,
  AuthUsersIndexRoute: AuthUsersIndexRoute,
  AuthDashboardsDcrUserIdRoute: AuthDashboardsDcrUserIdRoute,
  AuthDashboardsSystemUserIdRoute: AuthDashboardsSystemUserIdRoute,
  AuthFeedbackSurveysNewRoute: AuthFeedbackSurveysNewRoute,
  AuthGeoLocationMoTravelHistoryUserIdRoute:
    AuthGeoLocationMoTravelHistoryUserIdRoute,
  AuthHrFormLeaveApplicationsApplicationIdRoute:
    AuthHrFormLeaveApplicationsApplicationIdRoute,
  AuthPublishBatchesBatchIdRoute: AuthPublishBatchesBatchIdRoute,
  AuthQuestionMonitorClassesRoute: AuthQuestionMonitorClassesRoute,
  AuthQuestionMonitorDistrictsRoute: AuthQuestionMonitorDistrictsRoute,
  AuthQuestionPapersProjectInstituteIdRoute:
    AuthQuestionPapersProjectInstituteIdRoute,
  AuthSettingsInstituteSubmissionsSubmissionIdRoute:
    AuthSettingsInstituteSubmissionsSubmissionIdRoute,
  AuthSettingsInstitutesCreateRoute: AuthSettingsInstitutesCreateRoute,
  AuthSettingsInstitutesUserMappingRoute:
    AuthSettingsInstitutesUserMappingRoute,
  AuthSettingsTeacherSubmissionsTeacherIdRoute:
    AuthSettingsTeacherSubmissionsTeacherIdRoute,
  AuthUsersCreateCategoryRoute: AuthUsersCreateCategoryRoute,
  AuthDashboardsDcrIndexRoute: AuthDashboardsDcrIndexRoute,
  AuthDashboardsSystemIndexRoute: AuthDashboardsSystemIndexRoute,
  AuthDashboardsZonalStatementIndexRoute:
    AuthDashboardsZonalStatementIndexRoute,
  AuthFeedbackSurveysIndexRoute: AuthFeedbackSurveysIndexRoute,
  AuthGeoLocationMoTravelHistoryIndexRoute:
    AuthGeoLocationMoTravelHistoryIndexRoute,
  AuthHrFormLeaveApplicationsIndexRoute: AuthHrFormLeaveApplicationsIndexRoute,
  AuthMarketPromotionAdjustmentIndexRoute:
    AuthMarketPromotionAdjustmentIndexRoute,
  AuthProductSpecimenDistributionIndexRoute:
    AuthProductSpecimenDistributionIndexRoute,
  AuthPromotionAdjustmentIndexRoute: AuthPromotionAdjustmentIndexRoute,
  AuthSettingsInstituteSubmissionsIndexRoute:
    AuthSettingsInstituteSubmissionsIndexRoute,
  AuthSettingsInstitutesIndexRoute: AuthSettingsInstitutesIndexRoute,
  AuthSettingsTeacherSubmissionsIndexRoute:
    AuthSettingsTeacherSubmissionsIndexRoute,
  AuthDashboardsZonalStatementUserIdExpenseRoute:
    AuthDashboardsZonalStatementUserIdExpenseRoute,
  AuthDashboardsZonalStatementUserIdSpecimenRoute:
    AuthDashboardsZonalStatementUserIdSpecimenRoute,
  AuthFeedbackSurveysSurveyIdEditRoute: AuthFeedbackSurveysSurveyIdEditRoute,
  AuthFeedbackSurveysSurveyIdSubmissionsRoute:
    AuthFeedbackSurveysSurveyIdSubmissionsRoute,
  AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute:
    AuthMarketPromotionAdjustmentPromoItemIdZmIdRoute,
  AuthProductSpecimenDistributionSpecimenIdZmIdRoute:
    AuthProductSpecimenDistributionSpecimenIdZmIdRoute,
  AuthPromotionAdjustmentPromoItemIdZmIdRoute:
    AuthPromotionAdjustmentPromoItemIdZmIdRoute,
  AuthQuestionMonitorInstitutesProjectInstituteIdRoute:
    AuthQuestionMonitorInstitutesProjectInstituteIdRoute,
  AuthSettingsInstitutesInstituteIdEditRoute:
    AuthSettingsInstitutesInstituteIdEditRoute,
  AuthFeedbackSurveysSurveyIdIndexRoute: AuthFeedbackSurveysSurveyIdIndexRoute,
  AuthMarketPromotionAdjustmentPromoItemIdIndexRoute:
    AuthMarketPromotionAdjustmentPromoItemIdIndexRoute,
  AuthProductSpecimenDistributionSpecimenIdIndexRoute:
    AuthProductSpecimenDistributionSpecimenIdIndexRoute,
  AuthPromotionAdjustmentPromoItemIdIndexRoute:
    AuthPromotionAdjustmentPromoItemIdIndexRoute,
  AuthQuestionMonitorInstitutesIndexRoute:
    AuthQuestionMonitorInstitutesIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  SsoRoute: SsoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
